(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(313);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; },
  "getInitialFilterParams": function() { return /* binding */ getInitialFilterParams; },
  "getInitialSearchId": function() { return /* binding */ getInitialSearchId; },
  "setInitialSearchState": function() { return /* binding */ setInitialSearchState; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(7632);
// EXTERNAL MODULE: ./node_modules/@themuse/experiment-client/build/index.js
var build = __webpack_require__(6680);
// EXTERNAL MODULE: ./node_modules/@themuse/snowplow-js-client/build/index.js
var snowplow_js_client_build = __webpack_require__(8580);
// EXTERNAL MODULE: ./src/hooks/UserContext.tsx + 1 modules
var UserContext = __webpack_require__(2344);
// EXTERNAL MODULE: ./src/utils/searchFacetItems.ts
var searchFacetItems = __webpack_require__(4299);
;// CONCATENATED MODULE: ./src/utils/searchFacets.ts
/**
 * Counts the number of selected filters by checking if values are non-empty.
 */ const countFilterValues = (count, value)=>{
    if (Array.isArray(value)) {
        return count + value.filter(Boolean).length;
    }
    if (value) {
        return count + 1;
    }
    return count;
};
/**
 * Calculates the total number of selected filters, including remote location adjustments.
 */ const getSelectedFiltersCount = (props)=>{
    const { filters , location , company , keyword  } = props;
    let filterCount = Object.values(filters).reduce(countFilterValues, 0);
    filterCount += keyword.userInputValue || keyword.userSelectedKeyword?.value ? 1 : 0;
    filterCount += company.userSelectedCompany?.value ? 1 : 0;
    filterCount += location.userSelectedLocation?.value ? 1 : 0;
    return filterCount;
};
const getFacetValuesFromFacetItems = (filterParamValue, facetItems)=>{
    const splitValues = decodeURIComponent(filterParamValue).split(",");
    return splitValues.map((elem)=>{
        const facetItem = facetItems.find((item)=>item.value.toLowerCase() === elem.toLowerCase());
        return facetItem ? facetItem.value : null;
    }).filter((elem)=>elem !== null);
};

// EXTERNAL MODULE: ./src/utils/featureFlags.ts
var featureFlags = __webpack_require__(7601);
;// CONCATENATED MODULE: ./src/hooks/FeatureFlagsContext.tsx



const defaultFeatureFlagsState = ()=>{
    const flags = (0,featureFlags/* getFeatureFlags */.BZ)();
    return Object.keys(flags).reduce((featureFlags, featureFlag)=>({
            ...featureFlags,
            [featureFlag.toUpperCase()]: false
        }), {});
};
const FeatureFlagsContext = /*#__PURE__*/ react.createContext(defaultFeatureFlagsState());
const FeatureFlagsProvider = (props)=>{
    const { featureFlags , children  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureFlagsContext.Provider, {
        value: featureFlags,
        children: children
    });
};
const useFeatureFlagsState = ()=>{
    const context = react.useContext(FeatureFlagsContext);
    if (context === undefined) {
        throw new Error("useFeatureFlagsState must be used within the FeatureFlagsProvider");
    }
    return context;
};
FeatureFlagsProvider.displayName = "FeatureFlagsProvider";
useFeatureFlagsState.displayName = "useFeatureFlagsState";


;// CONCATENATED MODULE: ./src/hooks/SearchFacetsContext.tsx


const defaultSearchFacetsState = {
    companyFacets: {
        perks_and_benefits: []
    }
};
const SearchFacetsStateContext = /*#__PURE__*/ react.createContext(defaultSearchFacetsState);
/**
 * Search  Context Provider
 *
 * How to use:
 *
 * Wrap the provider around the components that need access to the context data.
 * ```
 * <SearchFacetProvider>
 *   <Component />
 * </SearchFacetProvider>
 * ```
 * Access the state in <Component />
 * ```
 * const state = useSearchFacetsState();
 * ```
 */ const SearchFacetsProvider = (props)=>{
    const { children , companyFacets  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFacetsStateContext.Provider, {
        value: {
            companyFacets
        },
        children: children
    });
};
const useSearchFacetsState = ()=>{
    const context = react.useContext(SearchFacetsStateContext);
    if (context === undefined) {
        throw new Error("useSearchFacetsState must be used within the SearchFacetsProvider.");
    }
    return context;
};
SearchFacetsProvider.displayName = "SearchFacetsProvider";
useSearchFacetsState.displayName = "useSearchFacetsState";


;// CONCATENATED MODULE: ./src/interfaces/context/searchContextInterfaces.ts
var LocationActionTypes;
(function(LocationActionTypes) {
    LocationActionTypes["updateLocation"] = "update_location";
    LocationActionTypes["updateLocationSuggestions"] = "update_location_suggestions";
    LocationActionTypes["resetLocation"] = "reset_location";
})(LocationActionTypes || (LocationActionTypes = {}));
var CompanyActionTypes;
(function(CompanyActionTypes) {
    CompanyActionTypes["updateCompany"] = "update_company";
    CompanyActionTypes["updateCompanySuggestions"] = "update_company_suggestions";
    CompanyActionTypes["resetCompany"] = "reset_company";
})(CompanyActionTypes || (CompanyActionTypes = {}));
var FiltersActionTypes;
(function(FiltersActionTypes) {
    FiltersActionTypes["updateFilter"] = "update_filter";
    FiltersActionTypes["resetAllFilters"] = "reset_all_filters";
})(FiltersActionTypes || (FiltersActionTypes = {}));
var KeywordActionTypes;
(function(KeywordActionTypes) {
    KeywordActionTypes["updateKeyword"] = "update_keyword";
    KeywordActionTypes["resetKeyword"] = "reset_keyword";
})(KeywordActionTypes || (KeywordActionTypes = {}));
var UserInteractionActionTypes;
(function(UserInteractionActionTypes) {
    UserInteractionActionTypes["updateJobTileViews"] = "update_job_tile_views";
    UserInteractionActionTypes["updateFilterInteraction"] = "update_filter_interaction";
    UserInteractionActionTypes["resetJobTileViews"] = "reset_job_tile_views";
})(UserInteractionActionTypes || (UserInteractionActionTypes = {}));
var UrlActionTypes;
(function(UrlActionTypes) {
    UrlActionTypes["updateUrl"] = "update_url";
})(UrlActionTypes || (UrlActionTypes = {}));
var WindowLocationActionTypes;
(function(WindowLocationActionTypes) {
    WindowLocationActionTypes["updateWindowLocation"] = "update_window_location";
})(WindowLocationActionTypes || (WindowLocationActionTypes = {}));
var SearchIdActionTypes;
(function(SearchIdActionTypes) {
    SearchIdActionTypes["updateSearchId"] = "update_search_id";
})(SearchIdActionTypes || (SearchIdActionTypes = {}));

;// CONCATENATED MODULE: ./src/reducers/locationReducer.ts

const defaultLocation = {
    label: "",
    latitude: null,
    longitude: null,
    value: "",
    remote_work_location_type: null
};
const defaultState = {
    userInputValue: "",
    userSelectedLocation: defaultLocation,
    locationSuggestions: []
};
/**
* A context reducer taking in a state and action, which in turn updates the context.
*/ const locationReducer = (state, action)=>{
    switch(action.type){
        case LocationActionTypes.updateLocation:
            {
                let userInputValue = action.payload?.userInputValue === "" ? "" : action.payload.userInputValue;
                let userSelectedLocation = action.payload?.userSelectedLocation || defaultLocation;
                if (action.payload?.userInputValue === "Flexible / Remote") {
                    userInputValue = "Remote / Flexible";
                }
                if (action.payload?.userSelectedLocation?.value === "Flexible / Remote") {
                    userSelectedLocation = {
                        label: "Remote / Flexible",
                        latitude: null,
                        longitude: null,
                        value: "Remote / Flexible",
                        remote_work_location_type: "virtual"
                    };
                }
                return {
                    ...state,
                    userInputValue,
                    userSelectedLocation
                };
            }
        case LocationActionTypes.updateLocationSuggestions:
            {
                const updatedState = {
                    ...state,
                    locationSuggestions: action.payload.locationSuggestions
                };
                return updatedState;
            }
        case LocationActionTypes.resetLocation:
            {
                return defaultState;
            }
        default:
            {
                return state;
            }
    }
};

;// CONCATENATED MODULE: ./src/reducers/companyReducer.ts

const companyReducer_defaultState = {
    userInputValue: "",
    userSelectedCompany: null,
    companySuggestions: []
};
const companyReducer = (state, action)=>{
    switch(action.type){
        case CompanyActionTypes.updateCompany:
            {
                const updatedState = {
                    ...state,
                    userInputValue: action.payload.userInputValue === null ? "" : action.payload.userInputValue,
                    userSelectedCompany: action.payload.userSelectedCompany
                };
                return updatedState;
            }
        case CompanyActionTypes.updateCompanySuggestions:
            {
                const updatedState1 = {
                    ...state,
                    companySuggestions: action.payload.companySuggestions
                };
                return updatedState1;
            }
        case CompanyActionTypes.resetCompany:
            {
                return companyReducer_defaultState;
            }
        default:
            {
                return state;
            }
    }
};

;// CONCATENATED MODULE: ./src/reducers/keywordReducer.ts

const keywordReducer_defaultState = {
    userInputValue: "",
    userSelectedKeyword: null
};
const keywordReducer = (state, action)=>{
    switch(action.type){
        case KeywordActionTypes.updateKeyword:
            {
                const updatedState = {
                    ...state,
                    ...action.payload
                };
                return updatedState;
            }
        case KeywordActionTypes.resetKeyword:
            {
                return keywordReducer_defaultState;
            }
        default:
            {
                return state;
            }
    }
};

;// CONCATENATED MODULE: ./src/reducers/filtersReducer.ts

const filtersReducer_defaultState = {
    category: [],
    industry: [],
    experienceLevel: [],
    perks: [],
    companySize: [],
    radius: "",
    postedDateRange: "",
    companyLeadership: []
};
const filtersReducer = (state, action)=>{
    switch(action.type){
        case FiltersActionTypes.updateFilter:
            {
                const updatedState = {
                    ...state,
                    ...action.payload
                };
                return updatedState;
            }
        case FiltersActionTypes.resetAllFilters:
            {
                return filtersReducer_defaultState;
            }
        default:
            {
                return state;
            }
    }
};

;// CONCATENATED MODULE: ./src/reducers/userInteractionsReducer.ts

const userInteractionsReducer = (state, action)=>{
    switch(action.type){
        case UserInteractionActionTypes.updateJobTileViews:
            {
                const updatedState = {
                    ...state,
                    tilesViewedJobIds: [
                        ...state.tilesViewedJobIds,
                        ...action.payload.tilesViewedJobIds
                    ]
                };
                return updatedState;
            }
        case UserInteractionActionTypes.resetJobTileViews:
            {
                const updatedState1 = {
                    ...state,
                    tilesViewedJobIds: []
                };
                return updatedState1;
            }
        case UserInteractionActionTypes.updateFilterInteraction:
            {
                const updatedState2 = {
                    ...state,
                    ...action.payload
                };
                return updatedState2;
            }
        default:
            {
                return state;
            }
    }
};

;// CONCATENATED MODULE: ./src/reducers/urlReducer.ts

const urlReducer = (state, action)=>{
    switch(action.type){
        case UrlActionTypes.updateUrl:
            {
                return action.payload;
            }
        default:
            {
                return state;
            }
    }
};

;// CONCATENATED MODULE: ./src/reducers/searchIdReducer.ts

const searchIdReducer = (state, action)=>{
    switch(action.type){
        case SearchIdActionTypes.updateSearchId:
            return action.payload;
        default:
            return state;
    }
};

// EXTERNAL MODULE: ./src/utils/reducers.ts
var reducers = __webpack_require__(5823);
;// CONCATENATED MODULE: ./src/hooks/SearchContext.tsx










const defaultSearchState = {
    location: {
        userInputValue: "",
        userSelectedLocation: {
            label: "",
            latitude: null,
            longitude: null,
            value: "",
            remote_work_location_type: null
        },
        locationSuggestions: []
    },
    company: {
        userInputValue: "",
        userSelectedCompany: null,
        companySuggestions: []
    },
    keyword: {
        userInputValue: "",
        userSelectedKeyword: null
    },
    filters: {
        category: [],
        industry: [],
        experienceLevel: [],
        perks: [],
        companySize: [],
        companyLeadership: []
    },
    userInteractions: {
        tilesViewedJobIds: []
    },
    url: "",
    preference: "",
    searchId: "",
    ctsEnabled: false
};
const SearchStateContext = /*#__PURE__*/ react.createContext(defaultSearchState);
const SearchDispatchContext = /*#__PURE__*/ react.createContext(undefined);
/**
 * Search  Context Provider
 *
 * How to use:
 *
 * Wrap the provider around the components that need access to the context data.
 * ```
 * <SearchProvider>
 *   <Component />
 * </SearchProvider>
 * ```
 * Access the state in <Component />
 * ```
 * const state = useSearchState();
 * ```
 * Call dispatch to update the context state
 * ```
 * const dispatch = useSearchDispatch();
 * dispatch({ type: ACTION_TYPE, payload: ACTION_PAYLOAD });
 * ```
 */ const SearchProvider = (props)=>{
    const { children , location , company , keyword , filters , userInteractions , preference , searchId , ctsEnabled  } = props;
    const [state, dispatch] = (0,reducers/* useCombinedReducers */.F)({
        location: react.useReducer(locationReducer, {
            ...defaultSearchState.location,
            ...location
        }),
        company: react.useReducer(companyReducer, {
            ...defaultSearchState.company,
            ...company
        }),
        keyword: react.useReducer(keywordReducer, {
            ...defaultSearchState.keyword,
            ...keyword
        }),
        filters: react.useReducer(filtersReducer, {
            ...defaultSearchState.filters,
            ...filters
        }),
        userInteractions: react.useReducer(userInteractionsReducer, {
            ...defaultSearchState.userInteractions,
            ...userInteractions
        }),
        url: react.useReducer(urlReducer, defaultSearchState.url),
        searchId: react.useReducer(searchIdReducer, searchId)
    });
    const searchState = (0,react.useMemo)(()=>({
            ...state,
            preference: preference ?? defaultSearchState.preference,
            ctsEnabled: ctsEnabled === true
        }), [
        state,
        preference,
        ctsEnabled
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchStateContext.Provider, {
        value: searchState,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchDispatchContext.Provider, {
            value: dispatch,
            children: children
        })
    });
};
const useSearchState = ()=>{
    const context = react.useContext(SearchStateContext);
    if (context === undefined) {
        throw new Error("useSearchState must be used within the SearchProvider");
    }
    return context;
};
const useSearchDispatch = ()=>{
    const context = react.useContext(SearchDispatchContext);
    if (context === undefined) {
        throw new Error("useSearchDispatch must be used within the SearchProvider");
    }
    return context;
};
SearchProvider.displayName = "SearchProvider";
useSearchState.displayName = "useSearchState";
useSearchDispatch.displayName = "useSearchDispatch";


;// CONCATENATED MODULE: ./src/hooks/SearchResultsContext.tsx


const SearchResultsStateContext = /*#__PURE__*/ react.createContext(undefined);
const SearchResultsDispatchContext = /*#__PURE__*/ react.createContext(undefined);
const searchResultsReducer = (state, action)=>{
    switch(action.type){
        case "update_results":
            {
                return {
                    ...state,
                    ...action.payload.values
                };
            }
        default:
            {
                throw new Error(`Unhandled action: ${action}`);
            }
    }
};
/**
 * Search Results Context Provider
 *
 * How to use:
 *
 * Wrap the provider around the components that need access to the context data.
 * ```
 * <SearchResultsProvider>
 *   <Component />
 * </SearchResultsProvider>
 * ```
 * Access the state in <Component />
 * ```
 * const state = useSearchResultsState();
 * ```
 * Call dispatch to update the context state
 * ```
 * const dispatch = useSearchResultsDispatch();
 * dispatch({ type: ACTION_TYPE, payload: ACTION_PAYLOAD });
 * ```
 */ const SearchResultsProvider = ({ children , ...initialState })=>{
    const [state, dispatch] = react.useReducer(searchResultsReducer, initialState);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResultsStateContext.Provider, {
        value: state,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResultsDispatchContext.Provider, {
            value: dispatch,
            children: children
        })
    });
};
const useSearchResultsState = ()=>{
    const context = react.useContext(SearchResultsStateContext);
    if (context === undefined) {
        throw new Error("useSearchResultsState must be used within the SearchResultsProvider");
    }
    return context;
};
const useSearchResultsDispatch = ()=>{
    const context = react.useContext(SearchResultsDispatchContext);
    if (context === undefined) {
        throw new Error("useSearchResultsDispatch must be used within the SearchResultsProvider");
    }
    return context;
};
SearchResultsProvider.displayName = "SearchResultsProvider";
useSearchResultsState.displayName = "useSearchResultsState";
useSearchResultsDispatch.displayName = "useSearchResultsDispatch";


// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/utils/strings.ts
var strings = __webpack_require__(2918);
;// CONCATENATED MODULE: ./src/components/header/Seo.tsx

/* eslint-disable max-len */ 




const Seo = (params)=>{
    const { company , keyword , location , filters  } = useSearchState();
    const { resolvedUrl  } = params;
    const { 0: canonical , 1: setCanonical  } = (0,react.useState)((0,strings/* getCanonicalUrl */.Z2)(resolvedUrl));
    const category = filters?.category.length === 1 ? filters?.category[0] : null;
    const { totalCount  } = useSearchResultsState();
    const seoTitle = (0,strings/* getSearchSeoTitle */.Y8)(location?.userSelectedLocation?.label, (0,strings/* unSlugify */.A$)(keyword?.userSelectedKeyword?.label), company?.userSelectedCompany?.label, category, totalCount);
    const title = `${seoTitle.suffix} | The Muse`;
    const description = (0,strings/* getSearchSeoDescription */.vU)(location?.userSelectedLocation?.label, (0,strings/* unSlugify */.A$)(keyword?.userSelectedKeyword?.label), company?.userSelectedCompany?.label, category, totalCount);
    (0,react.useEffect)(()=>{
        const handlePopstate = ()=>{
            const clientPath = `${window.location.pathname}${window.location.search}`;
            setCanonical((0,strings/* getCanonicalUrl */.Z2)(clientPath));
        };
        window.addEventListener("pushstate-event", handlePopstate);
        return ()=>{
            window.removeEventListener("pushstate-event", handlePopstate);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1"
            }, "viewport"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "robots",
                content: canonical ? "index,follow" : "noindex,follow"
            }, "robots"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: description
            }, "description"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: description
            }, "og:description"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: title
            }, "og:title"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:url",
                content: canonical
            }, "og:url"),
            canonical ? /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "canonical",
                href: canonical
            }, "canonical") : null
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Pages/Layout.tsx + 19 modules
var Layout = __webpack_require__(318);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Buttons/SquareButton.tsx + 1 modules
var SquareButton = __webpack_require__(1410);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Dropdowns/ComposableDropdown/DropdownProvider.tsx + 3 modules
var DropdownProvider = __webpack_require__(5085);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useDebounce.js + 1 modules
var useDebounce = __webpack_require__(5386);
// EXTERNAL MODULE: ./node_modules/downshift/dist/downshift.esm.js + 3 modules
var downshift_esm = __webpack_require__(9194);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/utils/logging.js
var logging = __webpack_require__(5023);
// EXTERNAL MODULE: ./src/utils/browser.ts
var browser = __webpack_require__(7228);
;// CONCATENATED MODULE: ./src/selectors/index.ts
const initialLocationList = [
    {
        label: "Remote / Flexible",
        value: "Remote / Flexible",
        latitude: null,
        longitude: null,
        remote_work_location_type: "virtual",
        id: 0
    },
    {
        label: "New York, NY",
        value: "New York, NY",
        latitude: 40.709999084472656,
        longitude: -74.01000213623047,
        remote_work_location_type: null,
        id: 5852770
    },
    {
        label: "San Francisco, CA",
        value: "San Francisco, CA",
        latitude: 37.77492904663086,
        longitude: -122.41941833496094,
        remote_work_location_type: null,
        id: 5834763
    },
    {
        label: "Los Angeles, CA",
        value: "Los Angeles, CA",
        latitude: 34.0522346496582,
        longitude: -118.24368286132812,
        remote_work_location_type: null,
        id: 5834138
    },
    {
        label: "Boston, MA",
        value: "Boston, MA",
        latitude: 42.36008071899414,
        longitude: -71.05888366699219,
        remote_work_location_type: null,
        id: 5845716
    },
    {
        label: "Washington, DC",
        value: "Washington, DC",
        latitude: 38.90719223022461,
        longitude: -77.03687286376953,
        remote_work_location_type: null,
        id: 5831724
    },
    {
        label: "Austin, TX",
        value: "Austin, TX",
        latitude: 30.267152786254883,
        longitude: -97.74305725097656,
        remote_work_location_type: null,
        id: 5862957
    },
    {
        label: "Chicago, IL",
        value: "Chicago, IL",
        latitude: 41.87811279296875,
        longitude: -87.62979888916016,
        remote_work_location_type: null,
        id: 5838173
    },
    {
        label: "Seattle, WA",
        value: "Seattle, WA",
        latitude: 47.60620880126953,
        longitude: -122.33206939697266,
        remote_work_location_type: null,
        id: 5865100
    },
    {
        label: "Atlanta, GA",
        value: "Atlanta, GA",
        latitude: 33.74899673461914,
        longitude: -84.38798522949219,
        remote_work_location_type: null,
        id: 5837145
    }
];
const unSelectedLocation = {
    label: "",
    latitude: null,
    longitude: null,
    remote_work_location_type: null,
    value: ""
};
const defaultInitialSearchLocation = {
    label: "",
    latitude: null,
    longitude: null,
    remote_work_location_type: null,
    value: ""
};
/**
 * Returns a selected location based on certain conditions.
 */ const selectedLocationSelector = (location)=>{
    const { userSelectedLocation =unSelectedLocation  } = location;
    const { latitude , remote_work_location_type ,  } = userSelectedLocation ?? defaultInitialSearchLocation;
    return !latitude && remote_work_location_type !== "virtual" ? defaultInitialSearchLocation : userSelectedLocation;
};
/**
 * Extracts the locationSuggestions and returns either the new suggestions or the default ones.
 */ const locationSuggestionsSelector = (location)=>{
    const { locationSuggestions  } = location;
    return locationSuggestions?.length ? locationSuggestions : initialLocationList;
};
/**
 * Extracts properties from search state and constructs an object containing the extracted and derived properties.
 */ const searchResultsSelector = (searchState)=>{
    const { location ={} , company ={} , keyword , filters , userInteractions , url , preference , searchId  } = searchState;
    const searchResultsLocation = selectedLocationSelector(location);
    const locationName = searchResultsLocation?.value ?? "";
    const { latitude , longitude  } = searchResultsLocation || {};
    // Checking for the userSelectedLocation value makes sure that the carmen location is not included in the request
    const latlng = latitude && longitude ? `${latitude},${longitude}` : null;
    const remoteOption = searchResultsLocation?.remote_work_location_type;
    // Get company-derived parameters
    const companyName = company.userSelectedCompany?.label;
    const companyShortName = company.userSelectedCompany?.value;
    // Get category-derived parameters;
    const category = filters?.category.length === 1 ? filters?.category[0] : null;
    // Get keyword-derived parameters
    const searchKeyword = keyword.userInputValue;
    return {
        company,
        location,
        keyword,
        filters,
        locationName,
        latitude,
        longitude,
        latlng,
        remoteOption,
        companyName,
        companyShortName,
        category,
        searchKeyword,
        userInteractions,
        url,
        preference,
        searchId
    };
};

;// CONCATENATED MODULE: ./src/hooks/SearchHistoryContext.tsx











const STORAGE_NAME = "tm_search_history";
const MAX_HISTORY_ENTRIES = 5;
// Define default context value
const defaultContextValue = {
    searchHistory: [],
    addHistory: ()=>{}
};
// Create the context
const SearchHistoryContext = /*#__PURE__*/ (0,react.createContext)(defaultContextValue);
/**
 * Returns a comma-separated string of labels corresponding to the selected values.
 */ const getLabels = (selected, target)=>target.filter((x)=>selected.includes(x.value)).map((x)=>x.label).join(" \u2022 ");
/**
 * Stores the search history in the local storage and triggers a storage event.
 * Logs an error message if the search history retrieval fails.
 */ const setLocalHistory = (searchHistory)=>{
    const { publicRuntimeConfig: { appName  }  } = (0,config["default"])();
    try {
        localStorage.setItem(STORAGE_NAME, JSON.stringify(searchHistory));
        window.dispatchEvent(new Event("storage"));
    } catch (error) {
        const msg = `${appName} was unable to store the users search history: ${JSON.stringify(searchHistory)}`;
        console.error(msg, JSON.stringify((0,logging/* formatLog */.U)({
            error
        })));
    }
};
/**
 * Retrieves the user's search history from local storage.
 * Logs an error message if the search history retrieval fails.
 */ const getLocalHistory = ()=>{
    const { publicRuntimeConfig: { appName  }  } = (0,config["default"])();
    let result = [];
    try {
        result = JSON.parse(localStorage.getItem(STORAGE_NAME));
    } catch (error) {
        const msg = `${appName} was unable to retrieve the users search history`;
        console.error(msg, JSON.stringify((0,logging/* formatLog */.U)({
            error
        })));
    }
    return Array.isArray(result) ? result : [];
};
/**
 * Builds a string array containing various search parameters and their corresponding labels.
 * If a parameter is not selected, its label is set to null.
 */ const getArrayOfSearchFilters = ({ keyword , company , location , filters , companyFacets  })=>{
    const keywordLabel = keyword?.userInputValue === keyword?.userSelectedKeyword?.label ? keyword?.userSelectedKeyword?.label : keyword?.userInputValue;
    const perks = companyFacets.perks_and_benefits.map((x)=>x.items).flat();
    const searchFilters = [
        keywordLabel,
        company?.userSelectedCompany?.label ?? null,
        location?.userSelectedLocation?.value ?? null,
        getLabels(filters.category, searchFacetItems/* jobCategoryItems */.Y0),
        getLabels(filters.industry, searchFacetItems/* companyIndustryItems */.fA),
        getLabels(filters.experienceLevel, searchFacetItems/* experienceLevelItems */.s),
        getLabels(filters.perks, perks),
        getLabels(filters.companySize, searchFacetItems/* companySizeItems */.NB),
        getLabels(filters.companyLeadership, searchFacetItems/* diversityInclusionItems */.uq),
        searchFacetItems/* searchRadiusItems.find */.Z5.find((x)=>x.value === filters.radius)?.label ?? null,
        searchFacetItems/* postedDateRangeItems.find */.dK.find((x)=>x.value === filters.postedDateRange)?.label ?? null, 
    ];
    return searchFilters.filter(Boolean)// remove defaults that are for display only
    .filter((x)=>![
            "Anywhere",
            "Anytime"
        ].includes(x))// Split combined filters
    .map((x)=>x.split(" \u2022 "))// convert back to a single array.
    .flat()// remove leading and trailing spaces
    .map((x)=>x.trim())// Remove empties
    .filter(Boolean);
};
/**
 * Saves search history to localStorage and localState.
 */ const generateNewHistory = (props)=>{
    const { companyShortName , locationName , searchKeyword , filters , asPath , setSearchHistory , keyword , company , location , companyFacets  } = props;
    const searchFilters = getArrayOfSearchFilters({
        keyword,
        company,
        location,
        filters,
        companyFacets
    });
    // generate the path, the async nature of populating the URL means we cannot trust `window.location.pathname`.
    const path = (0,browser/* generateUrlPath */.lT)({
        companyShortName,
        locationName: (0,strings/* normalizeLocationName */.DU)(locationName),
        searchKeyword,
        filters,
        asPath
    });
    // Reasons to not generate a history
    const allowNewHistory = path && ![
        "/search/",
        "/hiring/"
    ].includes(path) && searchFilters.length && searchFilters.join(" \u2022 ");
    // Generate a history item for the current search.
    const currentSearch = allowNewHistory ? [
        {
            path,
            text: searchFilters.join(" \u2022 "),
            filters: searchFilters.length
        }
    ] : [];
    // LocalStorage history minus the current search.
    const filteredHistory = getLocalHistory().filter((x)=>x.path !== path);
    // Only return our maxim history
    const results = [
        ...currentSearch,
        ...filteredHistory
    ].flat().slice(0, MAX_HISTORY_ENTRIES);
    // push to local state
    setSearchHistory(results);
    // push to local storage
    setLocalHistory(results);
};
/**
 * Provides a context for managing search history entries.
 */ const SearchHistoryProvider = ({ children  })=>{
    const router = (0,next_router.useRouter)() || {
        asPath: ""
    };
    const { asPath  } = router;
    const { 0: searchHistory , 1: setSearchHistory  } = (0,react.useState)([]);
    const { companyFacets  } = useSearchFacetsState();
    const searchState = useSearchState();
    const { company , location , keyword , filters , locationName , companyShortName , searchKeyword ,  } = searchResultsSelector(searchState);
    const updateLocalState = ()=>(event)=>{
            // we only care about these specific storage changes.
            if (event && event.key !== STORAGE_NAME) return;
            const history = getLocalHistory();
            setSearchHistory(history);
        };
    (0,react.useEffect)(()=>{
        addHistory();
    }, []);
    // Watch for changes to local storage.
    // Inject the current pages history into local storage
    (0,react.useEffect)(()=>{
        window.addEventListener("storage", updateLocalState);
        return ()=>{
            window.removeEventListener("storage", updateLocalState);
        };
    }, []);
    const addHistory = ()=>generateNewHistory({
            companyShortName,
            locationName,
            searchKeyword,
            filters,
            asPath,
            setSearchHistory,
            keyword,
            company,
            location,
            companyFacets
        });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchHistoryContext.Provider, {
        value: {
            searchHistory,
            addHistory
        },
        children: children
    });
};
SearchHistoryProvider.displayName = "SearchHistoryProvider";
// Custom hook for using the SearchHistory context.
const useSearchHistory = ()=>{
    const context = (0,react.useContext)(SearchHistoryContext);
    if (context === undefined) {
        throw new Error("useSearchHistory must be used within the SearchProvider");
    }
    return context;
};

// EXTERNAL MODULE: ./src/orm/locations.ts
var locations = __webpack_require__(7248);
// EXTERNAL MODULE: ./src/utils/api.ts + 8 modules
var api = __webpack_require__(4361);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Dropdowns/ComposableSearchDropdown.tsx + 1 modules
var ComposableSearchDropdown = __webpack_require__(2821);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Icons/IconCompany.tsx
var IconCompany = __webpack_require__(452);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(3135);
// EXTERNAL MODULE: ./src/styles/Home.module.scss
var Home_module = __webpack_require__(4865);
var Home_module_default = /*#__PURE__*/__webpack_require__.n(Home_module);
// EXTERNAL MODULE: ./src/components/header/SearchInput.module.scss
var SearchInput_module = __webpack_require__(8619);
var SearchInput_module_default = /*#__PURE__*/__webpack_require__.n(SearchInput_module);
;// CONCATENATED MODULE: ./src/components/header/CompanySearchInput.tsx







const menuToggle = (value)=>{
    const navHeader = document.querySelectorAll("header[class^='Header_header']");
    navHeader.forEach((elem)=>{
        if (value) {
            elem.classList.add((Home_module_default()).inputMenuOpen);
        } else {
            elem.classList.remove((Home_module_default()).inputMenuOpen);
        }
    });
};
const CompanySearchInput = (props)=>{
    const { company , clear , onInputChange , noResultsMessage  } = props;
    const { companySuggestions , userSelectedCompany  } = company;
    const placeHolderText = "All Companies";
    const dropdownProps = {
        classes: {
            container: (SearchInput_module_default()).searchInputContainer,
            inputIcon: (SearchInput_module_default()).inputIcon
        },
        dropdownProps: {
            IconComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCompany/* default */.Z, {}),
            dropdownList: companySuggestions,
            dropdownTitle: "Type to select a company",
            debounceWait: 200,
            labelText: "Companies",
            placeHolderText,
            inputId: "company-input",
            maxLength: constants/* suggestionApiQueryMaxlength */.BU,
            onInputChange,
            onMenuToggle: menuToggle,
            clearValue: clear,
            fieldValue: userSelectedCompany,
            showMenuOnFocus: true,
            refocusMobileOnClear: true,
            noResultsMessage
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComposableSearchDropdown/* default */.Z, {
        ...dropdownProps
    });
};
CompanySearchInput.displayName = "CompanySearchInput";
/* harmony default export */ var header_CompanySearchInput = (CompanySearchInput);

;// CONCATENATED MODULE: ./src/components/header/KeywordSearchInput.tsx






const KeywordSearchInput_menuToggle = (value)=>{
    const navHeader = document.querySelectorAll("header[class^='Header_header']");
    navHeader.forEach((elem)=>{
        if (value) {
            elem.classList.add((Home_module_default()).inputMenuOpen);
        } else {
            elem.classList.remove((Home_module_default()).inputMenuOpen);
        }
    });
};
const filterList = (list, value = "")=>list.filter((item)=>item.label.toLowerCase().includes(value.toLowerCase()));
const KeywordSearchInput = (props)=>{
    const { keyword , clear , onInputChange , noResultsMessage  } = props;
    const { userSelectedKeyword , userInputValue  } = keyword;
    const keywordList = [
        {
            label: "Marketing",
            value: "marketing"
        },
        {
            label: "Sales",
            value: "sales"
        },
        {
            label: "Product Management",
            value: "product manager"
        },
        {
            label: "Design",
            value: "design"
        },
        {
            label: "Software Engineering",
            value: "software engineering"
        },
        {
            label: "Human Resources",
            value: "human resources"
        },
        {
            label: "Finance",
            value: "finance"
        },
        {
            label: "Project Management",
            value: "project management"
        },
        {
            label: "Customer Care",
            value: "customer care"
        },
        {
            label: "Data Entry",
            value: "data entry"
        },
        {
            label: "Account Manager",
            value: "account manager"
        },
        {
            label: "Accountant",
            value: "accountant"
        },
        {
            label: "Accounting",
            value: "accounting"
        },
        {
            label: "Actuary",
            value: "actuary"
        },
        {
            label: "Admin",
            value: "admin"
        },
        {
            label: "Administrative",
            value: "administrative"
        },
        {
            label: "Administrative Assistant",
            value: "administrative assistant"
        },
        {
            label: "Analyst",
            value: "analyst"
        },
        {
            label: "Analytics",
            value: "analytics"
        },
        {
            label: "Art",
            value: "art"
        },
        {
            label: "Art Director",
            value: "art director"
        },
        {
            label: "Assistant",
            value: "assistant"
        },
        {
            label: "Associate Consultant",
            value: "associate consultant"
        },
        {
            label: "Brand Manager",
            value: "brand manager"
        },
        {
            label: "Brand Marketing",
            value: "brand marketing"
        },
        {
            label: "Business",
            value: "business"
        },
        {
            label: "Business Analyst",
            value: "business analyst"
        },
        {
            label: "Business Development",
            value: "business development"
        },
        {
            label: "Chief Of Staff",
            value: "chief of staff"
        },
        {
            label: "Clinical Educator",
            value: "clinical educator"
        },
        {
            label: "Coach",
            value: "coach"
        },
        {
            label: "Communication",
            value: "communication"
        },
        {
            label: "Communications",
            value: "communications"
        },
        {
            label: "Community Health Worker",
            value: "community health worker"
        },
        {
            label: "Community Manager",
            value: "community manager"
        },
        {
            label: "Compensation And Benefits Manager",
            value: "compensation and benefits manager"
        },
        {
            label: "Compliance",
            value: "compliance"
        },
        {
            label: "Computer Programmer",
            value: "computer programmer"
        },
        {
            label: "Content",
            value: "content"
        },
        {
            label: "Content Marketing",
            value: "content marketing"
        },
        {
            label: "Content Marketing Manager",
            value: "content marketing manager"
        },
        {
            label: "Content Writer",
            value: "content writer"
        },
        {
            label: "Coordinator",
            value: "coordinator"
        },
        {
            label: "Copy Editor",
            value: "copy editor"
        },
        {
            label: "Copywriter",
            value: "copywriter"
        },
        {
            label: "Corporate Communications",
            value: "corporate communications"
        },
        {
            label: "Creative",
            value: "creative"
        },
        {
            label: "Creative Director",
            value: "creative director"
        },
        {
            label: "Curriculum Developer",
            value: "curriculum developer"
        },
        {
            label: "Customer",
            value: "customer"
        },
        {
            label: "Customer Service",
            value: "customer service"
        },
        {
            label: "Customer Service Representative",
            value: "customer service representative"
        },
        {
            label: "Customer Success",
            value: "customer success"
        },
        {
            label: "Customer Success Manager",
            value: "customer success manager"
        },
        {
            label: "Customer Support",
            value: "customer support"
        },
        {
            label: "Data",
            value: "data"
        },
        {
            label: "Data Analyst",
            value: "data analyst"
        },
        {
            label: "Data Entry Clerk",
            value: "data entry clerk"
        },
        {
            label: "Data Intern",
            value: "data intern"
        },
        {
            label: "Data Management Analyst",
            value: "data management analyst"
        },
        {
            label: "Data Science",
            value: "data science"
        },
        {
            label: "Data Science Manager",
            value: "data science manager"
        },
        {
            label: "Data Scientist",
            value: "data scientist"
        },
        {
            label: "Database Administrator",
            value: "database administrator"
        },
        {
            label: "Digital Marketing",
            value: "digital marketing"
        },
        {
            label: "Director",
            value: "director"
        },
        {
            label: "Diversity Manager",
            value: "diversity manager"
        },
        {
            label: "Editing",
            value: "editing"
        },
        {
            label: "Editor",
            value: "editor"
        },
        {
            label: "Editorial Assistant",
            value: "editorial assistant"
        },
        {
            label: "Education",
            value: "education"
        },
        {
            label: "Engineering",
            value: "engineering"
        },
        {
            label: "English Teacher",
            value: "english teacher"
        },
        {
            label: "Enterprise Sales Executive",
            value: "enterprise sales executive"
        },
        {
            label: "Entry Level",
            value: "entry level"
        },
        {
            label: "Environmental Restoration Planner",
            value: "environmental restoration planner"
        },
        {
            label: "Event",
            value: "event"
        },
        {
            label: "Executive",
            value: "executive"
        },
        {
            label: "Executive Assistant",
            value: "executive assistant"
        },
        {
            label: "Fashion",
            value: "fashion"
        },
        {
            label: "Financial Analyst",
            value: "financial analyst"
        },
        {
            label: "Financial Manager",
            value: "financial manager"
        },
        {
            label: "Graphic Design",
            value: "graphic design"
        },
        {
            label: "Graphic Designer",
            value: "graphic designer"
        },
        {
            label: "Health",
            value: "health"
        },
        {
            label: "Healthcare",
            value: "healthcare"
        },
        {
            label: "HR",
            value: "hr"
        },
        {
            label: "HR Associate",
            value: "hr associate"
        },
        {
            label: "HR Manager",
            value: "hr manager"
        },
        {
            label: "HRIS Manager",
            value: "hris manager"
        },
        {
            label: "Industrial Engineer",
            value: "industrial engineer"
        },
        {
            label: "Information Security Analyst",
            value: "information security analyst"
        },
        {
            label: "Information Technology",
            value: "information technology"
        },
        {
            label: "Insurance Sales Agent",
            value: "insurance sales agent"
        },
        {
            label: "Intern",
            value: "intern"
        },
        {
            label: "Internal Auditing Manager",
            value: "internal auditing manager"
        },
        {
            label: "Internship",
            value: "internship"
        },
        {
            label: "Internships",
            value: "internships"
        },
        {
            label: "Interpreter",
            value: "interpreter"
        },
        {
            label: "Interview",
            value: "interview"
        },
        {
            label: "Learning",
            value: "learning"
        },
        {
            label: "Learning And Development",
            value: "learning and development"
        },
        {
            label: "Learning And Development Specialist",
            value: "learning and development specialist"
        },
        {
            label: "Legal",
            value: "legal"
        },
        {
            label: "Loan Officer",
            value: "loan officer"
        },
        {
            label: "Management Consultant",
            value: "management consultant"
        },
        {
            label: "Manager",
            value: "manager"
        },
        {
            label: "Marketing Analyst",
            value: "marketing analyst"
        },
        {
            label: "Marketing Consultant",
            value: "marketing consultant"
        },
        {
            label: "Marketing Manager",
            value: "marketing manager"
        },
        {
            label: "Marketing Specialist",
            value: "marketing specialist"
        },
        {
            label: "Mechanical Engineer",
            value: "mechanical engineer"
        },
        {
            label: "Medical Device Sales",
            value: "medical device sales"
        },
        {
            label: "Medical Writer",
            value: "medical writer"
        },
        {
            label: "Mental Health",
            value: "mental health"
        },
        {
            label: "Nonprofit",
            value: "nonprofit"
        },
        {
            label: "Nonprofits",
            value: "nonprofits"
        },
        {
            label: "Operations",
            value: "operations"
        },
        {
            label: "Operations Research Analyst",
            value: "operations research analyst"
        },
        {
            label: "Paralegal",
            value: "paralegal"
        },
        {
            label: "Part Time",
            value: "part time"
        },
        {
            label: "Pharmaceutical Sales",
            value: "pharmaceutical sales"
        },
        {
            label: "Pharmacist",
            value: "pharmacist"
        },
        {
            label: "Pharmacy Technician",
            value: "pharmacy technician"
        },
        {
            label: "Physician Assistant",
            value: "physician assistant"
        },
        {
            label: "Policy Analyst",
            value: "policy analyst"
        },
        {
            label: "PR",
            value: "pr"
        },
        {
            label: "PR Manager",
            value: "pr manager"
        },
        {
            label: "Procurement",
            value: "procurement"
        },
        {
            label: "Product",
            value: "product"
        },
        {
            label: "Product Manager",
            value: "product manager"
        },
        {
            label: "Product Marketing",
            value: "product marketing"
        },
        {
            label: "Program Manager",
            value: "program manager"
        },
        {
            label: "Project",
            value: "project"
        },
        {
            label: "Project Manager",
            value: "project manager"
        },
        {
            label: "Proofreader",
            value: "proofreader"
        },
        {
            label: "Public Relations",
            value: "public relations"
        },
        {
            label: "Python",
            value: "python"
        },
        {
            label: "Real Estate",
            value: "real estate"
        },
        {
            label: "Recruiter",
            value: "recruiter"
        },
        {
            label: "Registered Nurse",
            value: "registered nurse"
        },
        {
            label: "Regulatory Affairs Manager",
            value: "regulatory affairs manager"
        },
        {
            label: "Remote",
            value: "remote"
        },
        {
            label: "Research",
            value: "research"
        },
        {
            label: "Research Analyst",
            value: "research analyst"
        },
        {
            label: "Sales Consultant",
            value: "sales consultant"
        },
        {
            label: "Sales Engineer",
            value: "sales engineer"
        },
        {
            label: "Sales Representative",
            value: "sales representative"
        },
        {
            label: "Salesforce",
            value: "salesforce"
        },
        {
            label: "School Counselor",
            value: "school counselor"
        },
        {
            label: "Scrum Master",
            value: "scrum master"
        },
        {
            label: "Security",
            value: "security"
        },
        {
            label: "Senior Product Management Director",
            value: "senior product management director"
        },
        {
            label: "Senior UX Designer",
            value: "senior ux designer"
        },
        {
            label: "SEO",
            value: "seo"
        },
        {
            label: "Social Media",
            value: "social media"
        },
        {
            label: "Social Media Coordinator",
            value: "social media coordinator"
        },
        {
            label: "Social Media Manager",
            value: "social media manager"
        },
        {
            label: "Social Worker",
            value: "social worker"
        },
        {
            label: "Software",
            value: "software"
        },
        {
            label: "Software Developer",
            value: "software developer"
        },
        {
            label: "Software Engineer",
            value: "software engineer"
        },
        {
            label: "Software Sales Executive",
            value: "software sales executive"
        },
        {
            label: "Solutions Architect",
            value: "solutions architect"
        },
        {
            label: "Strategy",
            value: "strategy"
        },
        {
            label: "Supply Chain",
            value: "supply chain"
        },
        {
            label: "Sustainability",
            value: "sustainability"
        },
        {
            label: "Teacher",
            value: "teacher"
        },
        {
            label: "Teaching Assistant",
            value: "teaching assistant"
        },
        {
            label: "Technical Writer",
            value: "technical writer"
        },
        {
            label: "Training",
            value: "training"
        },
        {
            label: "Translator",
            value: "translator"
        },
        {
            label: "Tutor",
            value: "tutor"
        },
        {
            label: "User Experience",
            value: "user experience"
        },
        {
            label: "UX",
            value: "ux"
        },
        {
            label: "UX Design",
            value: "ux design"
        },
        {
            label: "UX Designer",
            value: "ux designer"
        },
        {
            label: "UX Researcher",
            value: "ux researcher"
        },
        {
            label: "Video",
            value: "video"
        },
        {
            label: "Virtual Assistant",
            value: "virtual assistant"
        },
        {
            label: "Web Developer",
            value: "web developer"
        },
        {
            label: "Work From Home",
            value: "work from home"
        },
        {
            label: "Writer",
            value: "writer"
        },
        {
            label: "Writing",
            value: "writing"
        }, 
    ];
    const dropdownProps = {
        classes: {
            container: (SearchInput_module_default()).searchInputContainer,
            inputIcon: (SearchInput_module_default()).inputIcon
        },
        dropdownProps: {
            dropdownList: filterList(keywordList, userInputValue),
            dropdownTitle: "Type to search for a job",
            onInputChange,
            inputId: "keyword-input",
            onMenuToggle: KeywordSearchInput_menuToggle,
            labelText: "Keyword",
            maxLength: constants/* jobSearchQueryMaxlength */.L8,
            clearValue: clear,
            fieldValue: userSelectedKeyword,
            noResultsMessage,
            placeHolderText: "Job title, keywords"
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComposableSearchDropdown/* default */.Z, {
        ...dropdownProps
    });
};
KeywordSearchInput.displayName = "KeywordSearchInput";
/* harmony default export */ var header_KeywordSearchInput = (KeywordSearchInput);

// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Icons/LocationShape.tsx
var LocationShape = __webpack_require__(9400);
;// CONCATENATED MODULE: ./src/components/header/LocationSearchInput.tsx







const LocationSearchInput_menuToggle = (value)=>{
    const navHeader = document.querySelectorAll("header[class^='Header_header']");
    navHeader.forEach((elem)=>{
        if (value) {
            elem.classList.add((Home_module_default()).inputMenuOpen);
        } else {
            elem.classList.remove((Home_module_default()).inputMenuOpen);
        }
    });
};
/**
 * Determines if a given label corresponds to a country-level location.
 */ const isCountryLocation = (label)=>!!label && constants/* countries.includes */.hW.includes(label);
/**
 * Filters a list of locations based on a search value and excludes country-level locations.
 */ const LocationSearchInput_filterList = (list, value = "")=>list// Filter by search value if provided
    .filter((item)=>item?.label?.toLowerCase().includes(value?.toLowerCase()))// Do not include country level searches.
    .filter((item)=>!isCountryLocation(item?.label));
/**
 * Renders a search input field with a dropdown for selecting locations. It utilizes ComposableSearchDropdown.
 */ const LocationSearchInput = (props)=>{
    const { location , clear , onClear , onInputChange , noResultsMessage  } = props;
    const { locationSuggestions , userSelectedLocation , userInputValue  } = location;
    const placeHolderText = "Anywhere";
    const dropdownProps = {
        classes: {
            container: (SearchInput_module_default()).searchInputContainer,
            inputIcon: (SearchInput_module_default()).inputIcon
        },
        dropdownProps: {
            dropdownList: LocationSearchInput_filterList(locationSuggestions, userInputValue),
            IconComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationShape/* default */.Z, {}),
            dropdownTitle: "Type to select a location",
            debounceWait: 200,
            labelText: "Locations",
            placeHolderText,
            inputId: "location-input",
            maxLength: constants/* suggestionApiQueryMaxlength */.BU,
            onInputChange,
            onMenuToggle: LocationSearchInput_menuToggle,
            clearValue: clear,
            onClear,
            fieldValue: userSelectedLocation,
            showMenuOnFocus: true,
            refocusMobileOnClear: true,
            noResultsMessage
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComposableSearchDropdown/* default */.Z, {
        ...dropdownProps
    });
};
LocationSearchInput.displayName = "LocationSearchInput";
/* harmony default export */ var header_LocationSearchInput = (LocationSearchInput);

;// CONCATENATED MODULE: ./src/components/header/SearchInput.tsx



// eslint-disable-next-line import/no-extraneous-dependencies














const SearchButton = (props)=>{
    const { onClick  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SquareButton/* default */.Z, {
        className: (SearchInput_module_default()).inputSubmit,
        color: "secondary-100",
        onClick: onClick,
        children: "Search"
    });
};
const NoResults = ()=>{
    const { onClearButtonClick  } = react.useContext(DropdownProvider/* DropdownContext */.D);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "No matches. Please",
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: (SearchInput_module_default()).noResultsButton,
                onClick: onClearButtonClick,
                type: "button",
                children: "try another search."
            })
        ]
    });
};
const NoResultsKeyword = ()=>{
    const { closeMenu , inputValue  } = react.useContext(DropdownProvider/* DropdownContext */.D);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        className: (SearchInput_module_default()).noResultsButtonKeyword,
        onClick: closeMenu,
        type: "button",
        children: [
            'See all results for "',
            inputValue,
            '"'
        ]
    });
};
const SearchInput = (props)=>{
    const { clearInputs , onClear  } = props;
    const searchState = useSearchState();
    const { addHistory  } = useSearchHistory();
    const { location , company  } = searchState;
    const locationUserInput = location.userInputValue ?? null;
    const companyUserInput = company.userInputValue ?? null;
    const searchDispatch = useSearchDispatch();
    // Handle clearInputs changes to reset the search fields
    react.useEffect(()=>{
        if (clearInputs) {
            // Reset all inputs in the context state
            searchDispatch({
                type: FiltersActionTypes.resetAllFilters
            });
            searchDispatch({
                type: CompanyActionTypes.resetCompany
            });
            searchDispatch({
                type: LocationActionTypes.resetLocation
            });
            searchDispatch({
                type: KeywordActionTypes.resetKeyword
            });
        }
    }, [
        clearInputs,
        searchDispatch
    ]);
    const clearValues = ()=>{
        onClear?.();
    };
    const setLocationSuggestions = async (locationInput)=>{
        if (typeof locationInput === "undefined") {
            return;
        }
        const rawSuggestions = await (0,api/* fetchLocationSuggestions */.gy)(locationInput);
        const suggestions = (0,locations/* formatLocations */.i)(rawSuggestions);
        searchDispatch({
            type: LocationActionTypes.updateLocationSuggestions,
            payload: {
                locationSuggestions: suggestions
            }
        });
    };
    const setCompanySuggestions = async (companyInput)=>{
        if (typeof companyInput === "undefined") return;
        const suggestions = await (0,api/* fetchCompanySuggestions */.SC)(companyInput);
        searchDispatch({
            type: CompanyActionTypes.updateCompanySuggestions,
            payload: {
                companySuggestions: suggestions
            }
        });
    };
    react.useEffect(()=>{
        setLocationSuggestions(locationUserInput);
        addHistory();
    }, [
        locationUserInput
    ]);
    react.useEffect(()=>{
        setCompanySuggestions(companyUserInput);
        addHistory();
    }, [
        companyUserInput
    ]);
    (0,useDebounce/* default */.Z)(()=>{
        addHistory();
    }, 500, [
        searchState.keyword
    ]);
    const updateLocationInput = (changes)=>{
        const { inputValue , selectedItem , type  } = changes;
        // item was clicked from dropdown
        const itemClicked = type === downshift_esm/* useCombobox.stateChangeTypes.ItemClick */.Kb.stateChangeTypes.ItemClick;
        // reset button was clicked with menu open
        const resetClickedMenuOpen = type === downshift_esm/* useCombobox.stateChangeTypes.FunctionReset */.Kb.stateChangeTypes.FunctionReset;
        // reset button was clicked with menu closed
        const resetClickedMenuClosed = type === downshift_esm/* useCombobox.stateChangeTypes.FunctionOpenMenu */.Kb.stateChangeTypes.FunctionOpenMenu;
        // input was cleared from input field
        const inputValueCleared = type === downshift_esm/* useCombobox.stateChangeTypes.InputChange */.Kb.stateChangeTypes.InputChange && inputValue === "";
        // user has entered a value into the input field
        const isEnteringData = type === downshift_esm/* useCombobox.stateChangeTypes.InputChange */.Kb.stateChangeTypes.InputChange && inputValue !== "";
        if (isEnteringData || itemClicked) {
            searchDispatch({
                type: LocationActionTypes.updateLocation,
                payload: {
                    userInputValue: inputValue,
                    userSelectedLocation: selectedItem
                }
            });
        }
        if (itemClicked) {
            // set initial radius if not remote/flexible
            if (!selectedItem?.remote_work_location_type) {
                searchDispatch({
                    type: FiltersActionTypes.updateFilter,
                    payload: {
                        radius: searchFacetItems/* initialRadiusValue */.kh
                    }
                });
            }
        }
        if (resetClickedMenuOpen || resetClickedMenuClosed || inputValueCleared) {
            searchDispatch({
                type: LocationActionTypes.updateLocation,
                payload: {
                    userInputValue: inputValue,
                    userSelectedLocation: null
                }
            });
            if (searchState?.filters?.radius) {
                searchDispatch({
                    type: FiltersActionTypes.updateFilter,
                    payload: {
                        radius: ""
                    }
                });
            }
        }
    };
    const updateCompanyInput = (changes)=>{
        const { inputValue , selectedItem , type  } = changes;
        // reset button was clicked with menu open
        const resetClickedMenuOpen = type === downshift_esm/* useCombobox.stateChangeTypes.FunctionReset */.Kb.stateChangeTypes.FunctionReset;
        // reset button was clicked with menu closed
        const resetClickedMenuClosed = type === downshift_esm/* useCombobox.stateChangeTypes.FunctionOpenMenu */.Kb.stateChangeTypes.FunctionOpenMenu;
        // input was cleared from input field
        const inputValueCleared = type === downshift_esm/* useCombobox.stateChangeTypes.InputChange */.Kb.stateChangeTypes.InputChange && inputValue === "";
        searchDispatch({
            type: CompanyActionTypes.updateCompany,
            payload: {
                userInputValue: inputValue,
                userSelectedCompany: selectedItem
            }
        });
        if (selectedItem) {
            searchDispatch({
                type: FiltersActionTypes.updateFilter,
                payload: {
                    industry: [],
                    perks: [],
                    companySize: []
                }
            });
        }
        if (resetClickedMenuOpen || resetClickedMenuClosed || inputValueCleared) {
            searchDispatch({
                type: CompanyActionTypes.updateCompany,
                payload: {
                    userInputValue: inputValue,
                    userSelectedCompany: null
                }
            });
        }
    };
    const updateKeywordInput = (changes)=>{
        const { inputValue , selectedItem , type  } = changes;
        // reset button was clicked with menu open
        const resetClickedMenuOpen = type === downshift_esm/* useCombobox.stateChangeTypes.FunctionReset */.Kb.stateChangeTypes.FunctionReset;
        // reset button was clicked with menu closed
        const resetClickedMenuClosed = type === downshift_esm/* useCombobox.stateChangeTypes.FunctionOpenMenu */.Kb.stateChangeTypes.FunctionOpenMenu;
        // input was cleared from input field
        const inputValueCleared = type === downshift_esm/* useCombobox.stateChangeTypes.InputChange */.Kb.stateChangeTypes.InputChange && inputValue === "";
        // New keyword implementation
        searchDispatch({
            type: KeywordActionTypes.updateKeyword,
            payload: {
                userInputValue: inputValue,
                userSelectedKeyword: selectedItem
            }
        });
        if (resetClickedMenuOpen || resetClickedMenuClosed || inputValueCleared) {
            searchDispatch({
                type: KeywordActionTypes.updateKeyword,
                payload: {
                    userInputValue: inputValue,
                    userSelectedKeyword: null
                }
            });
        }
    };
    const onSearchButtonClick = ()=>{
        if (!(0,browser/* isMobile */.tq)()) {
            searchDispatch({
                type: UserInteractionActionTypes.updateFilterInteraction,
                payload: {
                    searchButtonClickedAt: Date.now()
                }
            });
        }
    };
    const formStyles = (SearchInput_module_default()).form;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        className: formStyles,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_KeywordSearchInput, {
                keyword: searchState.keyword,
                clear: clearInputs,
                onClear: clearValues,
                onInputChange: updateKeywordInput,
                noResultsMessage: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoResultsKeyword, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_CompanySearchInput, {
                company: searchState.company,
                clear: clearInputs,
                onClear: clearValues,
                onInputChange: updateCompanyInput,
                noResultsMessage: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoResults, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_LocationSearchInput, {
                clear: clearInputs,
                onClear: clearValues,
                onInputChange: updateLocationInput,
                location: {
                    ...searchState.location,
                    // populates the dropdown
                    locationSuggestions: locationSuggestionsSelector(searchState.location)
                },
                noResultsMessage: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoResults, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchButton, {
                onClick: onSearchButtonClick
            })
        ]
    });
};
SearchInput.displayName = "SearchInput";
/* harmony default export */ var header_SearchInput = (SearchInput);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/deep-equal/index.js
var deep_equal = __webpack_require__(251);
var deep_equal_default = /*#__PURE__*/__webpack_require__.n(deep_equal);
;// CONCATENATED MODULE: ./src/utils/searchResults.ts

/**
 * Convert an array to a string with commas.
 */ const joinIfArray = (prop)=>Array.isArray(prop) ? prop.join(",") : prop;
/**
 * Collect the params from both the user inputs and the existing query string.
 * With User params taking precedents.
 * We do not collect the cursor as that is a special circumstance
 */ const getParams = ({ filters , companyShortName , searchKeyword , remoteOption , latlng , cursor , searchApiPreference , limit =20 , from_param  })=>{
    const inputParams = {
        query: searchKeyword,
        company_short_name: companyShortName,
        level: joinIfArray(filters?.experienceLevel),
        employee_range: joinIfArray(filters?.companySize),
        latlng,
        remote_work_location_type: remoteOption,
        company_industry: joinIfArray(filters?.industry),
        perks_and_benefits: joinIfArray(filters?.perks),
        category: joinIfArray(filters?.category),
        radius: latlng ? filters?.radius : null,
        posted_date_range: filters?.postedDateRange,
        company_leadership_attributes: joinIfArray(filters?.companyLeadership),
        preference: searchApiPreference,
        limit
    };
    // This should really not be here, we need to read this into state properly
    // const queryParams = parseQueryParamsToObject(window.location.search);
    const userParams = (0,reducers/* removeFalsy */.S)(inputParams);
    return {
        ...Number.isInteger(from_param) ? {
            from_param,
            size: limit
        } : {
            start_after: cursor,
            limit
        },
        ...userParams
    };
};

// EXTERNAL MODULE: ./src/orm/jobs.ts
var jobs = __webpack_require__(2919);
;// CONCATENATED MODULE: ./src/utils/searchFacetsTracking.ts
const snowplowFilterNameMap = new Map();
snowplowFilterNameMap.set("category", "Job Category").set("companyLeadership", "Diversity & Inclusion").set("companySize", "Company Size").set("experienceLevel", "Experience Level").set("industry", "Company Industry").set("perks", "Perks & Benefits").set("postedDateRange", "Date Posted").set("radius", "Search Radius").set("company", "Company Name").set("location", "Location");
const buildSnowplowFilterItems = (filters, location, company)=>{
    const items = [];
    const modifiedFilters = {
        ...filters
    };
    if (location) {
        Object.assign(modifiedFilters, {
            location: [
                location
            ]
        });
    }
    if (filters.location && !location) {
        delete modifiedFilters.location;
    }
    if (company) {
        Object.assign(modifiedFilters, {
            company: [
                company
            ]
        });
    }
    if (filters.company && !company) {
        delete modifiedFilters.company;
    }
    Object.keys(modifiedFilters).forEach((key)=>{
        if (!snowplowFilterNameMap.get(key) || !modifiedFilters[key].length) return;
        if (Array.isArray(modifiedFilters[key])) {
            modifiedFilters[key].forEach((val)=>{
                items.push({
                    filter_name: snowplowFilterNameMap.get(key),
                    filter_value: val
                });
            });
        } else {
            items.push({
                filter_name: snowplowFilterNameMap.get(key),
                filter_value: modifiedFilters[key]
            });
        }
    });
    return items;
};

// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/hooks/useJobAlertHistory/useJobAlertHistory.tsx + 1 modules
var useJobAlertHistory = __webpack_require__(1818);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Icons/IconBell.tsx
var IconBell = __webpack_require__(5945);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Modals/Modal.tsx
var Modal = __webpack_require__(2869);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/JobAlertsContextual/JobAlertsContextual.tsx + 4 modules
var JobAlertsContextual = __webpack_require__(7622);
// EXTERNAL MODULE: ./src/components/content/Modals/JobAlertsModal.module.scss
var JobAlertsModal_module = __webpack_require__(9413);
var JobAlertsModal_module_default = /*#__PURE__*/__webpack_require__.n(JobAlertsModal_module);
;// CONCATENATED MODULE: ./src/components/content/Modals/JobAlertsModal.tsx







const JobAlertsModal = ({ filterProps , isOpen , onSubscribed =()=>{} , setIsOpen  })=>{
    const contentRef = (0,react.useRef)(null);
    const prevOpen = (0,react.useRef)(isOpen);
    const { 0: isSuccess , 1: setIsSuccess  } = (0,react.useState)(false);
    const { locationValue , modalActionProps  } = (0,react.useMemo)(()=>{
        const location = filterProps.location === "Remote / Flexible" ? "Flexible / Remote" : filterProps.location || null;
        return {
            locationValue: location,
            modalActionProps: {
                sp_modal_type: "job_alert",
                sp_modal_action_type: "submit",
                sp_modal_job_category: filterProps.category || null,
                sp_modal_job_location: location,
                sp_modal_newsletter_opt_in: null,
                sp_modal_screen_order: null,
                sp_modal_screen_name: null
            }
        };
    }, [
        filterProps.category,
        filterProps.location
    ]);
    const categoryLabel = (0,react.useMemo)(()=>{
        const { category  } = filterProps;
        return searchFacetItems/* jobCategoryItems.find */.Y0.find((x)=>x.value === category)?.label || category;
    }, [
        filterProps.category
    ]);
    const handleFormSubmit = (0,react.useCallback)((formData)=>{
        /* eslint-disable-next-line @typescript-eslint/no-unused-vars */ const { special , ...filters } = filterProps;
        const apiData = {
            page_section: "search",
            ...filters,
            location: locationValue,
            ...formData
        };
        return (0,api/* jobAlertsSubscribeRequest */.Ml)(apiData);
    }, [
        filterProps,
        locationValue
    ]);
    const handleFormSuccess = (0,react.useCallback)((formData)=>{
        setIsSuccess(true);
        onSubscribed(formData);
        (0,snowplow_js_client_build.triggerSnowplowModalActionEvent)({
            ...modalActionProps,
            sp_modal_newsletter_opt_in: formData?.newsletter
        });
    }, [
        modalActionProps,
        onSubscribed
    ]);
    const handleFormError = (0,react.useCallback)(()=>{
        (0,snowplow_js_client_build.triggerSnowplowModalActionEvent)({
            ...modalActionProps,
            sp_modal_error_type: "Job Alerts subscription was unsuccessful."
        });
    }, [
        modalActionProps
    ]);
    (0,react.useEffect)(()=>{
        if (!isOpen && prevOpen.current) {
            (0,snowplow_js_client_build.triggerSnowplowModalActionEvent)({
                ...modalActionProps,
                sp_modal_action_type: "close"
            });
        }
        if (isOpen && !prevOpen.current) {
            (0,snowplow_js_client_build.triggerSnowplowImpressionEvent)(contentRef.current);
        }
        prevOpen.current = isOpen;
    }, [
        isOpen,
        modalActionProps
    ]);
    (0,react.useEffect)(()=>{
        if (isSuccess) {
            (0,snowplow_js_client_build.triggerSnowplowImpressionEvent)(contentRef.current);
        }
    }, [
        isSuccess
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        containerClassName: (JobAlertsModal_module_default()).container,
        contentClassName: (JobAlertsModal_module_default()).content,
        isOpen: isOpen,
        label: "Job Alerts",
        setIsOpen: setIsOpen,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            "data-tracking-props": JSON.stringify({
                sp_impression_component: "modal",
                sp_impression_modal_type: isSuccess ? "job_alert_success" : "job_alert",
                sp_impression_position: "pop_up"
            }),
            ref: contentRef,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(JobAlertsContextual/* default */.Z, {
                filterProps: {
                    ...filterProps,
                    category: categoryLabel
                },
                onFormError: handleFormError,
                onFormSubmit: handleFormSubmit,
                onFormSuccess: handleFormSuccess
            })
        })
    });
};
JobAlertsModal.displayName = "JobAlertsModal";

// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/DirectApply/DirectApply.tsx + 97 modules
var DirectApply = __webpack_require__(9219);
// EXTERNAL MODULE: ./src/components/content/Modals/DirectApplyModal.module.scss
var DirectApplyModal_module = __webpack_require__(9661);
var DirectApplyModal_module_default = /*#__PURE__*/__webpack_require__.n(DirectApplyModal_module);
;// CONCATENATED MODULE: ./src/components/content/Modals/DirectApplyModal.tsx





// filler app
const noop = ()=>{};
// generate iframe and modal
const DirectApplyModal = ({ link , isDirectApplyOpen , setIsDirectApplyOpen , companyId , companyName , endpoint , jobId , jobCategory , normalizedTitle , level , jobName , locations , atsJobId , service  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        title: "Direct Apply Modal Wrapper",
        children: [
            service === "mega" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DirectApply/* default */.Z, {
                companyId,
                companyName,
                endpoint,
                isOpen: isDirectApplyOpen,
                jobId,
                jobCategory,
                normalizedTitle,
                level,
                jobName,
                link,
                locations,
                setIsOpen: setIsDirectApplyOpen,
                signUpCallBack: api/* combinedSubscribe */.xi,
                atsJobId,
                service,
                showMoreJobsButton: true
            }) : null,
            service === "iframe" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                label: "Direct Apply Modal.",
                isOpen: isDirectApplyOpen,
                setIsOpen: setIsDirectApplyOpen,
                onOpen: noop,
                onClose: noop,
                timer: 0,
                closeButtonClassName: (DirectApplyModal_module_default()).jobApplyModalCloseButton,
                containerClassName: (DirectApplyModal_module_default()).jobApplyModalContainer,
                contentClassName: (DirectApplyModal_module_default()).jobApplyModalContent,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                    title: "greenhouse apply frame",
                    src: `${link}#application`,
                    width: "300",
                    height: "500",
                    loading: "lazy",
                    seamless: true
                })
            }) : null
        ]
    });
DirectApplyModal.displayName = "DirectApplyModal";

;// CONCATENATED MODULE: ./src/components/content/Modals/index.tsx



// EXTERNAL MODULE: ./src/components/content/SearchHeader/AlertCTA.module.scss
var AlertCTA_module = __webpack_require__(7614);
var AlertCTA_module_default = /*#__PURE__*/__webpack_require__.n(AlertCTA_module);
;// CONCATENATED MODULE: ./src/components/content/SearchHeader/AlertCTA.tsx







const AlertCTA = ({ category , company , keyword , level , location  })=>{
    const { filterKey , filterProps  } = (0,react.useMemo)(()=>{
        if ([
            category,
            keyword,
            level,
            location
        ].every((s)=>!s) || company) {
            return {
                filterKey: "empty",
                filterProps: null
            };
        }
        const props = Object.entries({
            category,
            keyword,
            level,
            location
        }).reduce((accum, [key, value])=>{
            if (value) {
                return {
                    ...accum,
                    [key]: value
                };
            }
            return accum;
        }, {});
        return {
            filterKey: new URLSearchParams(props).toString(),
            filterProps: props
        };
    }, [
        category,
        company,
        keyword,
        level,
        location
    ]);
    const { append , hasAlert  } = (0,useJobAlertHistory/* default */.Z)(filterProps);
    const { 0: modalOpen , 1: setModalOpen  } = (0,react.useState)(false);
    const handleSubscribed = (0,react.useCallback)(()=>{
        append(filterProps);
    }, [
        append,
        filterProps
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SquareButton/* default */.Z, {
                className: classnames_default()((AlertCTA_module_default()).alertCTA, {
                    [(AlertCTA_module_default()).alertCTAHidden]: !filterProps
                }),
                color: "light-blue",
                "data-testid": "alert-cta__button",
                disabled: hasAlert || !filterProps,
                onClick: ()=>setModalOpen(true),
                children: [
                    "Set Job Alert",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconBell/* default */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(JobAlertsModal, {
                filterProps: filterProps || {},
                isOpen: modalOpen,
                onSubscribed: handleSubscribed,
                setIsOpen: setModalOpen
            }, filterKey)
        ]
    });
};

// EXTERNAL MODULE: ./src/components/content/SearchHeader/Heading.module.scss
var Heading_module = __webpack_require__(8635);
var Heading_module_default = /*#__PURE__*/__webpack_require__.n(Heading_module);
;// CONCATENATED MODULE: ./src/components/content/SearchHeader/Heading.tsx




const Heading = (props)=>{
    const { location , keyword , company , category , state  } = props;
    const total = state.totalCount;
    const headerStringObj = (0,strings/* getSearchSeoTitle */.Y8)(location, (0,strings/* unSlugify */.A$)(keyword), company, category, total);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
        className: (Heading_module_default()).total,
        "data-testid": "search-heading",
        children: [
            total > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: headerStringObj.totalString
            }),
            headerStringObj.suffix
        ]
    });
};
Heading.displayName = "Heading";

// EXTERNAL MODULE: ./src/components/content/SearchHeader/SearchHeader.module.scss
var SearchHeader_module = __webpack_require__(3172);
var SearchHeader_module_default = /*#__PURE__*/__webpack_require__.n(SearchHeader_module);
;// CONCATENATED MODULE: ./src/components/content/SearchHeader/SearchHeader.tsx




const SearchHeader = (props)=>{
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */ const { state , ...alertProps } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (SearchHeader_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                ...props
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertCTA, {
                ...alertProps
            })
        ]
    });
};
SearchHeader.displayName = "SearchHeader";

;// CONCATENATED MODULE: ./src/components/content/SearchHeader/index.ts


// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Icons/ArrowDownShape.tsx
var ArrowDownShape = __webpack_require__(8053);
// EXTERNAL MODULE: ./src/components/content/LoadMore.module.scss
var LoadMore_module = __webpack_require__(7686);
var LoadMore_module_default = /*#__PURE__*/__webpack_require__.n(LoadMore_module);
;// CONCATENATED MODULE: ./src/components/content/LoadMore.tsx




/**
 * Renders the load more button if there are in fact more results to get.
 */ const LoadMore = (params)=>{
    const { cb  } = params;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SquareButton/* default */.Z, {
        className: (LoadMore_module_default()).loadMore,
        color: "secondary-100",
        onClick: cb,
        children: [
            "Load More Results",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDownShape/* default */.Z, {})
        ]
    });
};
LoadMore.displayName = "LoadMore";


// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Icons/ArrowRightShape.tsx
var ArrowRightShape = __webpack_require__(7621);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(7650);
;// CONCATENATED MODULE: ./src/utils/tracking.tsx

/* eslint-disable camelcase */ 


/**
 * TrackedElement: Wraps an element in an intersection observer with tracking props.
 */ const TrackedElement = (props)=>{
    const { children , eventProps , enabled =true , callback , ...restProps } = props;
    const intersectionProps = {
        triggerOnce: true,
        rootMargin: "0px",
        ...restProps
    };
    const { ref , inView , entry  } = (0,react_intersection_observer_modern/* useInView */.YD)(intersectionProps);
    let viewed = false;
    const trackingProps = {
        ...eventProps
    };
    (0,react.useEffect)(()=>{
        if (inView && enabled) {
            if (callback) {
                callback();
            }
            if (trackingProps?.sp_impression_component && !viewed) {
                (0,snowplow_js_client_build.triggerSnowplowImpressionEvent)(entry.target);
                viewed = true;
            }
        }
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: ref,
        "data-tracking-props": JSON.stringify(eventProps),
        children: children
    });
};
/**
 * genJobTrackingProps: Generate the props for a tracked element.
 */ const genJobTrackingProps = (job)=>({
        company_id: job.hit.company.legacy_id,
        company_name: job.hit.company.name,
        company_short_name: job.hit.company.short_name,
        job_id: job.hit.legacy_id,
        job_level: job.hit.levels.map((level)=>level.code),
        job_locations: job.hit.locations.map((location)=>location.address),
        job_name: job.hit.title,
        job_short_name: job.hit.short_title,
        job_type: job.hit.apply_type,
        sp_impression_component: "tile",
        sp_impression_tile_type: "job",
        sp_tile_type: "job",
        sp_tile_entity_id: job.hit.legacy_id.toString(),
        sp_tile_entity_uuid: job.hit.id,
        sp_tile_company_id: job.hit.company.legacy_id.toString(),
        sp_tile_location: "search"
    });


// EXTERNAL MODULE: ./src/components/icons/NullLogo.module.scss
var NullLogo_module = __webpack_require__(1601);
var NullLogo_module_default = /*#__PURE__*/__webpack_require__.n(NullLogo_module);
;// CONCATENATED MODULE: ./src/components/icons/NullLogo.tsx


/**
 * Renders an SVG component representing a placeholder or null logo.
 */ const NullLogo = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        className: (NullLogo_module_default()).nullLogo,
        width: "80",
        height: "80",
        viewBox: "0 0 29 37",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_611_2508)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M28.5 35.0277C28.5 35.2929 28.3946 35.5473 28.2071 35.7348C28.0196 35.9223 27.7652 36.0277 27.5 36.0277H14.5V1.9717C14.4999 1.78781 14.5504 1.60745 14.6461 1.45043C14.7418 1.29341 14.879 1.16582 15.0425 1.08169C15.206 0.997558 15.3895 0.96014 15.5729 0.973549C15.7563 0.986959 15.9325 1.05068 16.082 1.1577L28.082 9.7297C28.2114 9.82232 28.3169 9.94451 28.3896 10.0861C28.4623 10.2277 28.5001 10.3845 28.5 10.5437V35.0277Z",
                        stroke: "#767676",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M26.4995 8.60008V3.02808",
                        stroke: "#767676",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M14.5 10.0282H18.5",
                        stroke: "#767676",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M14.5 16.028H20.5",
                        stroke: "#767676",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M0.499756 22.028H6.49976",
                        stroke: "#767676",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M0.499756 28.0281H6.49976",
                        stroke: "#767676",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M14.5 22.028H23.5",
                        stroke: "#767676",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M18.5002 36.0281V29.0281C18.5002 28.7629 18.6056 28.5085 18.7931 28.321C18.9807 28.1334 19.235 28.0281 19.5002 28.0281H23.5002C23.7655 28.0281 24.0198 28.1334 24.2074 28.321C24.3949 28.5085 24.5002 28.7629 24.5002 29.0281V36.0281",
                        stroke: "#767676",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M14.4998 16.028H1.49976C1.23454 16.028 0.980185 16.1333 0.792649 16.3208C0.605113 16.5084 0.499756 16.7627 0.499756 17.028V35.028C0.499756 35.2932 0.605113 35.5475 0.792649 35.7351C0.980185 35.9226 1.23454 36.028 1.49976 36.028H14.4998",
                        stroke: "#767676",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_611_2508",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "29",
                        height: "37",
                        fill: "white"
                    })
                })
            })
        ]
    });
NullLogo.displayName = "NullLogo";

// EXTERNAL MODULE: ./src/components/content/JobTileMinimal.module.scss
var JobTileMinimal_module = __webpack_require__(9617);
var JobTileMinimal_module_default = /*#__PURE__*/__webpack_require__.n(JobTileMinimal_module);
;// CONCATENATED MODULE: ./src/components/content/JobTileMinimal.tsx

/* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable camelcase */ 








/**
 * Attempt to pull the closest matching location out of the job.
 */ const getJobTileLocation = (props)=>{
    const { inputDMA , remote_work_location_type , locations , userLocationDma  } = props;
    const isRemote = remote_work_location_type === "virtual";
    // We always prefer the dropdown if it was used.
    const userLocation = inputDMA || userLocationDma;
    // We Only care about the actual location address and fallback to country.
    // eslint-disable-next-line max-len
    const locationStrings = locations.map((x)=>!/\w/.test(x.address) ? x.country.toUpperCase() : x.address);
    // This is the fully matched location (city and state).
    const matchedLocation = locationStrings.find((loc)=>loc === userLocation);
    // We may need to match only on the last segment of the location.
    const getState = (txt)=>{
        if (typeof txt === "string") {
            return txt.split(",")[1]?.trim()?.toLowerCase();
        }
        return null;
    };
    // First location matched by region.
    const matchedRegion = locationStrings.find((address)=>getState(address) === getState(userLocation));
    // First location in the list (fall back)
    const firstLocation = locationStrings[0];
    // The location to display
    const displayLocation = matchedLocation || matchedRegion || firstLocation || "";
    // If we have more than 2 locations pluralize the string.
    const locationWord = ` location${locationStrings.length > 2 ? "s" : ""}`;
    // If we have more than 1 location we add a plus sign and the number plus the word location(s)
    const extraLocations = locationStrings.length > 1 ? ` + ${locationStrings.length - 1}${locationWord}` : "";
    // If we are remote and there is a location we will separate them with a slash.
    const separator = displayLocation ? " / " : "";
    // Build the remote string.
    const remoteString = isRemote ? `${separator}Remote` : "";
    // all together now...
    return [
        `${displayLocation}${remoteString}${extraLocations}`
    ];
};
/**
 * Generates the tracking props for a card.
 * Returns an object.
 */ const getTrackingProps = (props)=>{
    const { job , viewJobHref , total , index , searchId  } = props;
    return {
        ...genJobTrackingProps(job),
        link_href: viewJobHref,
        total_results_on_page: total,
        placement: "search_results",
        order_num: index + 1,
        sp_tile_order: index + 1,
        sp_tile_search_id: searchId,
        sp_impression_search_id: searchId
    };
};
/**
 * Generates Snowplow event base data for the various job tile click events.
 */ const getSnowplowEventData = (eventData)=>{
    const { searchId , companyLegacyId , legacy_id , snowplow_id , index ,  } = eventData;
    return {
        sp_click_component: "button",
        sp_click_component_tile_type: "job",
        sp_click_button_type: null,
        sp_click_position: "main",
        sp_click_target_page_section: "job_detail",
        sp_click_search_id: searchId,
        sp_tile_type: "job",
        sp_tile_company_id: companyLegacyId?.toString() ?? "",
        sp_tile_entity_id: legacy_id?.toString() ?? "",
        sp_tile_entity_uuid: snowplow_id,
        sp_tile_location: null,
        sp_tile_order: index + 1
    };
};
/**
 * JobTileMinimal is similar to the JobTile but has fewer buttons and very different triggers.
 */ const JobTileMinimal = ({ job , total , inputDMA , userLocationDma , viewed , index , selectedJob , setSelectedJob , setIsOpen ,  })=>{
    const searchDispatch = useSearchDispatch();
    const { searchId  } = useSearchState();
    const { company: { legacy_id: companyLegacyId , logo , name , short_name , pkg , client_tier  } , id , legacy_id , locations , postedDate , remote_work_location_type , short_title , snowplow_id , title ,  } = job.hit;
    const { 0: imageError , 1: setImageError  } = (0,react.useState)(false);
    const companyHref = `/profiles/${short_name}`;
    const viewJobHref = `/jobs/${short_name}/${short_title}`;
    const ctaLabel = `View ${title}. This opens in a new tab.`;
    // a list of rules for using the fallback logo
    const logoRules = [
        // Some payment tiers do not have logos or profiles.
        [
            "archived",
            "lite"
        ].includes(client_tier),
        pkg === null,
        // Sometimes we have not yet received the companies logo.
        !logo,
        // An error loading the logo.
        imageError
    ];
    const logoImage = logoRules.some(Boolean) ? null : logo;
    /**
     * Generates the tracking properties for a job tile.
     */ const trackingProps = getTrackingProps({
        job,
        viewJobHref,
        total,
        index,
        searchId
    });
    /**
     * Generates the location of a job tile based on various location parameters.
     */ const tileLocation = getJobTileLocation({
        inputDMA,
        remote_work_location_type,
        locations,
        userLocationDma
    });
    /**
     * Generates the Snowplow event data for tracking purposes.
     */ const eventData = getSnowplowEventData({
        searchId,
        companyLegacyId,
        legacy_id,
        snowplow_id: snowplow_id || id,
        index
    });
    /**
     * Handles the click event on the entire job tile.
     *
     * Stops the event from propagating and prevents the default action.
     * Triggers a Snowplow click event with specific tracking data.
     * Sets the active job.
     * Shows the job description iframe.
     */ const handleTileClick = (event)=>{
        event.stopPropagation();
        event.preventDefault();
        (0,snowplow_js_client_build.triggerSnowplowClickEvent)({
            ...eventData,
            sp_click_component: "tile"
        });
        const jobPath = `${job.hit.company.short_name}/${job.hit.short_title}`;
        const params = new URLSearchParams(window.location.search);
        const jobParam = params.get("job") || "1";
        const page = window.location.pathname.startsWith("/search") ? 1 : parseInt(jobParam, 10);
        setSelectedJob(jobPath);
        (0,strings/* pushUrl */.ir)(page, window.location.pathname, jobPath);
        setIsOpen(true);
    };
    /**
     * Handles the click event on a view job link within a job tile.
     *
     * Stops the event from propagating and prevents the default action.
     * Triggers a Snowplow click event with specific tracking data.
     * Opens the job description page in a new browser tab.
     */ const handleViewClick = (event)=>{
        event.stopPropagation();
        event.preventDefault();
        (0,snowplow_js_client_build.triggerSnowplowClickEvent)({
            ...eventData,
            sp_click_component: "button",
            sp_click_button_type: "job_view",
            sp_click_button_text: "View Job >"
        });
        window.open(viewJobHref, "_blank");
    };
    /**
     * Handles the click event on a company name link within a job tile.
     *
     * Stops the event from propagating and prevents the default action.
     * Triggers a Snowplow click event with specific tracking data.
     * Opens the company's profile page in a new browser tab.
     */ const handleCompanyClick = (event)=>{
        event.stopPropagation();
        event.preventDefault();
        (0,snowplow_js_client_build.triggerSnowplowClickEvent)({
            ...eventData,
            sp_click_component: "tile",
            sp_click_button_type: "profile",
            sp_click_button_text: name,
            sp_click_target_page_section: "profile"
        });
        window.open(companyHref, "_blank");
    };
    const isSelectedJob = selectedJob?.includes(`${job.hit.company.short_name}/${job.hit.short_title}`);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackedElement, {
        eventName: "Job Tile Viewed",
        eventProps: trackingProps,
        enabled: !viewed,
        callback: ()=>searchDispatch({
                type: UserInteractionActionTypes.updateJobTileViews,
                payload: {
                    tilesViewedJobIds: [
                        id
                    ]
                }
            }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: `${(JobTileMinimal_module_default()).jobTile} ${isSelectedJob ? (JobTileMinimal_module_default()).selected : ""}`,
            onClick: handleTileClick,
            role: "presentation",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (JobTileMinimal_module_default()).logo,
                    children: logoImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: logoImage,
                        alt: "",
                        width: "100",
                        height: "100",
                        loading: "eager",
                        onError: ()=>setImageError(true)
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NullLogo, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (JobTileMinimal_module_default()).body,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: (JobTileMinimal_module_default()).title,
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (JobTileMinimal_module_default()).details,
                            children: [
                                "At",
                                " ",
                                !pkg || pkg === "Programmatic" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: name
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: companyHref,
                                    onClick: handleCompanyClick,
                                    onContextMenuCapture: handleCompanyClick,
                                    children: name
                                }),
                                " ",
                                "-",
                                tileLocation
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (JobTileMinimal_module_default()).details,
                            children: [
                                "Posted on",
                                " ",
                                postedDate
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            className: (JobTileMinimal_module_default()).cta,
                            href: viewJobHref,
                            "aria-label": ctaLabel,
                            onClick: handleViewClick,
                            onContextMenuCapture: handleViewClick,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "View Job"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightShape/* default */.Z, {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: " "
                })
            ]
        })
    }, `tracked-${id}`);
};
JobTileMinimal.displayName = "JobTileMinimal";
/* harmony default export */ var content_JobTileMinimal = (JobTileMinimal);

// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Cards/EmptyResult.tsx + 1 modules
var EmptyResult = __webpack_require__(5933);
// EXTERNAL MODULE: ./src/components/content/Empty.module.scss
var Empty_module = __webpack_require__(752);
var Empty_module_default = /*#__PURE__*/__webpack_require__.n(Empty_module);
;// CONCATENATED MODULE: ./src/components/content/Empty.tsx



/**
 * Uhho screen renders when there are zero results
 */ const Empty = (params)=>{
    const { requested , results , cb  } = params;
    return requested && !results ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Empty_module_default()).empty,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyResult/* default */.Z, {
            title: "Uh-oh.",
            details: "We couldn\u2019t find any jobs that match your search. Please try clearing all your filters, entering a new keyword, or searching in a different location.",
            buttonCta: "Clear my Search",
            onClick: cb
        })
    }) : null;
};
Empty.displayName = "Empty";


// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Icons/ArrowLeftShape.tsx
var ArrowLeftShape = __webpack_require__(3399);
// EXTERNAL MODULE: ./src/components/content/Pagination.module.scss
var Pagination_module = __webpack_require__(6822);
var Pagination_module_default = /*#__PURE__*/__webpack_require__.n(Pagination_module);
;// CONCATENATED MODULE: ./src/components/content/Pagination.tsx

/* eslint-disable jsx-a11y/anchor-is-valid */ // This is a workaround for the fact that Google does not crawl buttons.






const Pagination = ({ activePage =1 , setActivePage , totalPages =1 , pagesToShow =5 , onPageChange =()=>{} , paginationContainerOverride ="" , paginationControlsOverride ="" , pageNumbersContainerOverride ="" , pageButtonOverride ="" , arrowButtonOverride ="" ,  })=>{
    const router = (0,next_router.useRouter)();
    const { 0: pathname , 1: setPathname  } = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        // Update pathname when URL changes (asPath) but only the path portion.
        setPathname(router.asPath.split("?")[0].split("#")[0]);
    }, [
        router.asPath
    ]);
    (0,react.useEffect)(()=>{
        (0,strings/* pushUrl */.ir)(activePage, window.location.pathname);
    }, [
        activePage
    ]);
    const handlePageChange = (page)=>{
        if (page >= 1 && page <= totalPages) {
            setActivePage(page);
            onPageChange(page);
            (0,strings/* pushUrl */.ir)(page, window.location.pathname);
        }
    };
    // Calculate which page numbers to display
    const getPageNumbers = ()=>{
        const pageNumbers = [];
        const numberLine = Math.min(pagesToShow, totalPages);
        let startPage = Math.max(1, activePage - Math.floor(numberLine / 2));
        const endPage = Math.min(totalPages, startPage + numberLine - 1);
        // Adjust startPage if we're near the end
        startPage = Math.max(1, endPage - numberLine + 1);
        for(let i = startPage; i <= endPage; i += 1){
            pageNumbers.push(i);
        }
        return pageNumbers;
    };
    const handlePaginationInteraction = (event)=>{
        const page = parseInt(event.target?.dataset?.page ?? "0", 10);
        event.preventDefault();
        handlePageChange(page);
        onPageChange(page);
    };
    const handleKeyPress = (e)=>{
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handlePaginationInteraction(e);
        }
    };
    const previousPage = activePage - 1 >= 1 ? activePage - 1 : null;
    const nextPage = activePage + 1 <= totalPages ? activePage + 1 : null;
    const pageNumbers = getPageNumbers();
    const arrowStyles = `${(Pagination_module_default()).pageButton} ${pageButtonOverride} ${(Pagination_module_default()).arrowButton} ${arrowButtonOverride}`;
    if (totalPages <= 1) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        className: `${(Pagination_module_default()).paginationContainer} ${paginationContainerOverride}`,
        "aria-label": "Pagination",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: `${(Pagination_module_default()).paginationControls} ${paginationControlsOverride}`,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: {
                        pathname,
                        // never query string to page 1
                        ...previousPage > 1 ? {
                            query: {
                                page: previousPage
                            }
                        } : null
                    },
                    shallow: true,
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        "aria-label": "Go to previous page",
                        className: `${arrowStyles} ${previousPage ? "" : (Pagination_module_default()).disabled}`,
                        "data-page": activePage - 1,
                        onClick: handlePaginationInteraction,
                        onKeyDown: handleKeyPress,
                        rel: previousPage ? "" : "nofollow",
                        role: "link",
                        tabIndex: 0,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeftShape/* default */.Z, {})
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: `${(Pagination_module_default()).pageNumbersContainer} ${pageNumbersContainerOverride}`,
                    children: pageNumbers.map((pageNumber)=>/*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: {
                                pathname,
                                // never query string to page 1
                                ...pageNumber > 1 ? {
                                    query: {
                                        page: pageNumber
                                    }
                                } : {}
                            },
                            shallow: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                "aria-current": pageNumber === activePage ? "page" : undefined,
                                "aria-label": `Go to page ${pageNumber}`,
                                className: `${(Pagination_module_default()).pageButton} ${pageButtonOverride}`,
                                "data-page": pageNumber,
                                onClick: handlePaginationInteraction,
                                onKeyDown: handleKeyPress,
                                role: "link",
                                tabIndex: 0,
                                children: pageNumber
                            })
                        }, pageNumber))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: {
                        pathname,
                        ...nextPage ? {
                            query: {
                                page: nextPage
                            }
                        } : {}
                    },
                    shallow: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        "aria-label": "Go to next page",
                        className: `${arrowStyles} ${nextPage ? "" : (Pagination_module_default()).disabled}`,
                        "data-page": activePage + 1,
                        onClick: handlePaginationInteraction,
                        onKeyDown: handleKeyPress,
                        rel: nextPage ? "" : "nofollow",
                        role: "link",
                        tabIndex: 0,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightShape/* default */.Z, {})
                    })
                })
            ]
        })
    });
};
Pagination.displayName = "Pagination";

// EXTERNAL MODULE: ./src/components/content/SearchResults.module.scss
var SearchResults_module = __webpack_require__(235);
var SearchResults_module_default = /*#__PURE__*/__webpack_require__.n(SearchResults_module);
;// CONCATENATED MODULE: ./src/components/content/SearchResults.tsx

/* eslint-disable camelcase */ 

























/**
 * Extract the closest matching location out of a job and format it for display in a job tile.
 */ const SearchResults_getJobTileLocation = (props)=>{
    const { inputDma , locationType , locations , sessionDma  } = props;
    const isRemote = locationType === "virtual";
    // We always prefer the dropdown if it was used.
    const userLocation = inputDma || sessionDma;
    // We Only care about the actual location address.
    const locationStrings = locations.map((location)=>location.address);
    // This is the fully matched location (city and state).
    const matchedLocation = locationStrings.filter((loc)=>loc === userLocation)[0];
    // We may need to match only on the last segment of the location.
    const getState = (txt)=>{
        if (typeof txt === "string") {
            return txt.split(",")[1]?.trim()?.toLowerCase();
        }
        return null;
    };
    // First location matched by region.
    const matchedRegion = locationStrings.filter((address)=>getState(address) === getState(userLocation))[0];
    // First location in the list (fall back)
    const firstLocation = locationStrings[0];
    // The location to display
    const displayLocation = matchedLocation || matchedRegion || firstLocation || "";
    // If we have more than 2 locations pluralize the string.
    const locationWord = ` location${locationStrings.length > 2 ? "s" : ""}`;
    // If we have more than 1 location we add a plus sign and the number plus the word location(s)
    const extraLocations = locationStrings.length > 1 ? ` + ${locationStrings.length - 1}${locationWord}` : "";
    // If we are remote and there is a location we will separate them with a slash.
    const separator = displayLocation ? " / " : "";
    // Build the remote string.
    const remoteString = isRemote ? `${separator}Remote` : "";
    // all together now...
    return [
        `${displayLocation}${remoteString}${extraLocations}`
    ];
};
const handleViewedCallback = (jobId, searchDispatch)=>{
    searchDispatch({
        type: UserInteractionActionTypes.updateJobTileViews,
        payload: {
            tilesViewedJobIds: [
                jobId
            ]
        }
    });
};
/**
 * Renders a list of JobTile components based on the search results passed.
 */ const Tiles = (props)=>{
    const searchDispatch = useSearchDispatch();
    const { searchResults , locationName , userInteractions , userLocationDma , resultsLength , selectedJob , setSelectedJob , setIsOpen  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: searchResults.map((job, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(content_JobTileMinimal, {
                job,
                index,
                inputDMA: locationName ?? "",
                userLocationDma,
                total: resultsLength,
                viewed: userInteractions.tilesViewedJobIds.includes(job.hit.id),
                selectedJob,
                setSelectedJob,
                setIsOpen,
                viewedCallback: ()=>handleViewedCallback(job.hit.id, searchDispatch)
            }, `${job.hit.id}`))
    });
};
Tiles.displayName = "Tiles";
/**
 * Render job search results and handling user interactions with the search results page.
 */ const SearchResults = (props)=>{
    const { onClear , setSelectedJob , selectedJob , setIsOpen , activePage , setActivePage  } = props;
    const { publicRuntimeConfig: { museWebHost  }  } = (0,config["default"])();
    const { location: userLocation  } = (0,UserContext/* useUserState */.e)();
    const searchDispatch = useSearchDispatch();
    const searchResultsState = useSearchResultsState();
    const { totalCount , results  } = searchResultsState;
    const searchResultsDispatch = useSearchResultsDispatch();
    const { ctsEnabled  } = useSearchState();
    const [jobsHasBeenRequested, setJobsHasBeenRequested] = react.useState(false);
    const [userLocationDma, setUserLocationDma] = react.useState("");
    const [hasMore, setHasMore] = react.useState(false);
    const [classState, setClassState] = react.useState((SearchResults_module_default()).resultsGrid);
    const [initialLoad, setInitialLoad] = react.useState(true);
    const [isHiring, setIsHiring] = react.useState(true);
    const searchState = useSearchState();
    const { company , location , keyword , filters , locationName , latitude , latlng , remoteOption , companyName , companyShortName , category , searchKeyword , userInteractions , url , preference , searchId  } = searchResultsSelector(searchState);
    const listRef = react.useRef(null);
    // eslint-disable-next-line arrow-body-style
    const jobLevel = react.useMemo(()=>{
        return filters?.experienceLevel?.filter(Boolean)?.shift()?.split(",")?.shift() ?? "";
    }, [
        filters?.experienceLevel
    ]);
    const [searchRequestState, setSearchRequestState] = react.useState({
        filters,
        companyShortName,
        searchKeyword,
        remoteOption,
        latlng,
        searchId
    });
    (0,useDebounce/* default */.Z)(()=>{
        // Handle any updated search params
        const updatedSearchRequestState = {
            filters,
            companyShortName,
            searchKeyword,
            remoteOption,
            latlng,
            searchId
        };
        if (!deep_equal_default()(updatedSearchRequestState, searchRequestState)) {
            setSearchRequestState(updatedSearchRequestState);
        }
    }, 500, [
        company,
        location,
        keyword,
        filters
    ]);
    const router = (0,next_router.useRouter)();
    const { asPath  } = router;
    // This is the search id we want to use for tracking
    let uniqueSearchId = searchId;
    // Deal with URL changing via history.pushState or next/router
    react.useEffect(()=>{
        // set on first Load
        setIsHiring(window.location.pathname.startsWith("/hiring/"));
        const handlePopstate = ()=>{
            const actualUrl = new URL(window.location.href);
            const page = parseInt(actualUrl.searchParams.get("page") ?? "1", 10);
            const pageTypeIsHiring = window.location.pathname.startsWith("/hiring/");
            setIsHiring(pageTypeIsHiring);
            setActivePage(page);
        };
        // update on push state
        window.addEventListener("pushstate-event", handlePopstate);
        return ()=>{
            window.removeEventListener("pushstate-event", handlePopstate);
        };
    }, []);
    /**
     * Push a new history state only after filter changes
     * * If we are on search remove the pagination entirely.
     */ react.useEffect(()=>{
        if (url) {
            const page = url.startsWith("/search") ? 1 : activePage;
            (0,strings/* pushUrl */.ir)(page, url);
        }
    }, [
        url
    ]);
    react.useEffect(()=>{
        if (!(initialLoad && !!searchId)) {
            uniqueSearchId = (0,v4/* default */.Z)();
            searchDispatch({
                type: SearchIdActionTypes.updateSearchId,
                payload: uniqueSearchId
            });
        }
    }, [
        searchRequestState
    ]);
    react.useEffect(()=>{
        // We load the first set of search results server
        // side, so we don't want to fetch on initial load.
        if (!initialLoad || !results.length) {
            const urlPath = (0,browser/* generateUrlPath */.lT)({
                companyShortName,
                locationName: (0,strings/* normalizeLocationName */.DU)(locationName),
                searchKeyword,
                filters,
                asPath
            });
            fetchJobSearchResults(isHiring ? {
                page: activePage
            } : {});
            searchDispatch({
                type: UrlActionTypes.updateUrl,
                payload: urlPath
            });
        }
        const searchEventProps = {
            sp_search_type: "job",
            sp_search_id: uniqueSearchId,
            sp_search_keyword: searchKeyword
        };
        const isRemote = remoteOption === "virtual";
        const snowplowFilters = buildSnowplowFilterItems(filters, locationName, companyShortName);
        (0,snowplow_js_client_build.triggerSnowplowSearchEvent)(searchEventProps, snowplowFilters, isRemote);
    }, [
        searchRequestState,
        userInteractions?.searchButtonClickedAt
    ]);
    react.useEffect(()=>{
        setHasMore(!!(totalCount - results.length));
    }, [
        totalCount,
        results.length
    ]);
    /**
     * setUserLocationDma are triggered when any of the following are modified:
     * userInputs location lat changes
     */ react.useEffect(()=>{
        setUserLocationDma(userLocation?.dma);
    }, [
        latitude
    ]);
    /**
     * Fetch jobs with an optional cursor Id.
     *
     * @param cursor This is the cursor within the last job on the page.
     * @returns Promise
     */ const fetchJobSearchResults = async ({ cursor ="" , page =0  })=>{
        setJobsHasBeenRequested(false);
        // if this is not a load more request and we are scrolled at all, snap back to the top.
        if (!cursor && window.scrollY) {
            window.scrollTo(0, 0);
        }
        const queryParams = getParams({
            filters,
            companyShortName,
            searchKeyword,
            remoteOption,
            latlng,
            cursor,
            searchApiPreference: preference,
            from_param: page ? (page - 1) * 20 : null
        });
        const jobsResponse = await (0,api/* fetchJobs */.bG)(queryParams, ctsEnabled);
        const dispatchValues = (0,jobs/* formatJobsResponse */.n)(jobsResponse);
        const update = cursor ? [
            ...searchResultsState.results,
            ...dispatchValues.results
        ] : [
            ...dispatchValues.results
        ];
        searchResultsDispatch({
            type: "update_results",
            payload: {
                values: {
                    ...dispatchValues,
                    results: update
                }
            }
        });
        setJobsHasBeenRequested(true);
    };
    /**
     * Clear all the search filters
     */ const clearSearch = ()=>{
        searchDispatch({
            type: FiltersActionTypes.resetAllFilters
        });
        searchDispatch({
            type: CompanyActionTypes.resetCompany
        });
        searchDispatch({
            type: LocationActionTypes.resetLocation
        });
        searchDispatch({
            type: KeywordActionTypes.resetKeyword
        });
        onClear?.();
    };
    /**
     * This is the event fired by the load more button.
     * @param event:  The click event.
     */ const handleLoadMoreClick = react.useCallback((event)=>{
        if (event) {
            event.preventDefault();
        }
        const { cursor =""  } = searchResultsState;
        fetchJobSearchResults({
            cursor
        });
    }, [
        searchResultsState.cursor
    ]);
    /**
     * This is the event fired by the pagination link.
     * @param event:  The click event.
     */ const handlePaginationClick = (page)=>{
        fetchJobSearchResults({
            page
        });
    };
    react.useEffect(()=>{
        const classes = classnames_default()(!isHiring && hasMore ? (SearchResults_module_default()).hasFade : false, (SearchResults_module_default()).resultsGrid);
        setClassState(classnames_default()(classes));
    }, [
        hasMore,
        jobsHasBeenRequested
    ]);
    const searchResults = searchResultsState.results ?? [];
    const resultsLength = searchResults.length ?? 0;
    const getLDJson = (list)=>{
        const itemListElement = list.map((job, index)=>{
            const { apply_type , short_title  } = job?.hit ?? {};
            const extension = apply_type === "external" ? "" : "#apply-inline-form";
            return {
                "@type": "ListItem",
                position: index + 1,
                url: `${museWebHost}/jobs/${job?.hit?.company?.short_name}/${short_title}${extension}`
            };
        });
        return JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ItemList",
            itemListElement
        });
    };
    const tilesProps = {
        searchResults,
        locationName,
        userInteractions,
        userLocationDma,
        resultsLength,
        searchDispatch,
        selectedJob,
        setSelectedJob,
        setIsOpen
    };
    react.useEffect(()=>{
        if (initialLoad) {
            setInitialLoad(false);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchHeader, {
                category: category,
                company: companyName ?? null,
                keyword: searchKeyword ?? null,
                level: jobLevel,
                location: locationName ?? null,
                state: searchResultsState
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    // using old style script and head so that this script will update on filter change.
                    type: "application/ld+json",
                    id: "ItemList",
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML: {
                        __html: getLDJson(searchResults)
                    }
                })
            }),
            resultsLength ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                ref: listRef,
                className: classState,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tiles, {
                        ...tilesProps
                    }),
                    isHiring && hasMore ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination, {
                        activePage,
                        setActivePage,
                        totalPages: totalCount / 20,
                        pagesToShow: 5,
                        onPageChange: (page)=>handlePaginationClick(page)
                    }) : null,
                    !isHiring && hasMore ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadMore, {
                        cb: handleLoadMoreClick
                    }) : null
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Empty, {
                requested: jobsHasBeenRequested,
                results: resultsLength,
                cb: clearSearch
            })
        ]
    });
};
SearchResults.displayName = "SearchResults";


// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/utils/string.js
var string = __webpack_require__(8340);
;// CONCATENATED MODULE: ./src/utils/titleNormalization.ts
/* eslint-disable quote-props */ // Direct trade B for A.
const replacers = {
    "assoc. ": "Associate",
    "assoc ": "Associate",
    "mgr. ": "Manager",
    "mgr ": "Manager",
    "part-time": "part time",
    "full-time": "full time",
    "sr.": "Senior",
    "jr.": "Junior"
};
// Completely remove.
const individualChars = [
    "sign on",
    "sign-on",
    "bonus",
    '"',
    "/",
    "*",
    "!",
    "%",
    "&",
    "+",
    ":",
    "$",
    "#",
    "|",
    "@",
    " . "
];
// Completely remove plus anything after.
const removeAfterChars = [
    " at ",
    " per hour ",
    " in ",
    " -",
    "(",
    "[",
    "{",
    "\\",
    ";",
    " | ",
    ",",
    "- "
];
/**
 * Escape characters for special string regex.
 */ const titleNormalization_escape = (x)=>x.replace(/[-[\]{}()/*+?.,\\^$|#\s]/g, "\\$&");
/**
 * Encode then double decode to remove any special characters
 */ const removeEncoding = (title)=>{
    let result = decodeURIComponent(encodeURIComponent(title));
    try {
        result = decodeURIComponent(result);
    } catch (e) {
    // do nothing its not encoded.
    }
    return result;
};
/**
 * Remove all HTML tags
 */ const removeHTML = (title)=>title.replace(/(<([^>]+)>)/ig, "").trim();
/**
 * Remove strings wrapped in braces.
 */ const removeBraceWrapped = (title)=>title.replace(/\{.+?\}/ig, "").trim();
/**
 * Remove strings wrapped in brackets.
 */ const removeBracketWrapped = (title)=>title.replace(/\[.+?\]/ig, "").trim();
/**
 * Remove strings wrapped in parentheses.
 */ const removeParenthesesWrapped = (title)=>title.replace(/\(.+?\)/ig, "").trim();
/**
 * Assume this character / string and everything after it is junk.
 */ const removeAfter = (title)=>removeAfterChars.reduce((prev, curr)=>{
        const re = new RegExp(titleNormalization_escape(curr), "ig");
        return prev.split(re)[0];
    }, title);
/**
 * Replace specific characters or phrases.
 */ const replaceMap = (title)=>Object.keys(replacers).reduce((prev, curr)=>{
        const re = new RegExp(titleNormalization_escape(curr), "ig");
        return prev.replace(re, replacers[curr]);
    }, title);
/**
 * Replace individual groupings with a space.
 */ const removeIndividual = (title)=>individualChars.reduce((prev, curr)=>{
        const re = new RegExp(titleNormalization_escape(curr), "ig");
        return prev.replace(re, " ");
    }, title);
/**
 * Remove roman numerals.
 */ const removeRomanNumerals = (title)=>title.replace(/\b(VI|V|IV|III|II|I)\b/, " ");
/**
 * Remove html encoded entities.
 */ const removeHtmlEntities = (title)=>title.replace(/&nbsp;|&apos;|&quot;|&gt;|&lt;|&amp;/ig, " ");
/**
 * Remove things that look like time.
 * * 0|01 - 24 hours
 * * followed by colon
 * * followed by 00-59
 * * followed by am or pm.
 */ const removeTime = (title)=>title.replace(/((?:\d|[01]\d|2[0-3]):[0-5]\d?([AP]M))/ig, " ");
/**
 * Remove strings that look like money.
 */ const removeMoney = (title)=>title.replace(/(\$?\d+,?\d+\.?\d+k?)|/ig, "");
/**
 * Removes anything at the end of the string that is not a letter.
 * Should be run last.
 */ const clearLastSymbol = (title)=>title.replace(/[^A-Z]+$/ig, "");
/**
 * Removes anything at the begining of the string that is a symbol.
 * Should be run last.
 */ const clearFirstSymbol = (title)=>title.replace(/^[\W_]+/ig, "");
/**
 * Removes leading standalone numbers followed by a space
 * Should be run in group 3.
 */ const clearLeadingNumbers = (title)=>title.replace(/^[\d\s-/]+\s/, "");
/**
 * Remove multiple whitespace characters including tab space linefeed backspace...
 */ const removeContiguousWhiteSpace = (title)=>title.replace(/\s+/g, " ").trim();
/**
 * Loop through each replacers, trimming after each pass.
 */ const titleNormalization = (title)=>{
    const starter = title.trim();
    const operations = [
        // # Round 1 Rules.  These cleanup the characters for the rest of the replacers.
        removeEncoding,
        removeHTML,
        removeHtmlEntities,
        removeBraceWrapped,
        removeBracketWrapped,
        removeParenthesesWrapped,
        // # Round 2 Rules.  These start removing huge chunks of text.
        replaceMap,
        removeMoney,
        removeTime,
        removeAfter,
        removeIndividual,
        removeRomanNumerals,
        // # Round 3 Rules.  These come near the end as numbers and such could get pushed to the edges.
        clearLastSymbol,
        clearFirstSymbol,
        clearLeadingNumbers,
        // # Round 4 Rule. Dead last to cleanup the whitespace.
        removeContiguousWhiteSpace, 
    ];
    const result = operations.reduce((prev, curr)=>curr.call(undefined, prev).trim(), starter);
    return result.trim();
};


// EXTERNAL MODULE: ./src/components/content/BrowseLinks.module.scss
var BrowseLinks_module = __webpack_require__(148);
var BrowseLinks_module_default = /*#__PURE__*/__webpack_require__.n(BrowseLinks_module);
;// CONCATENATED MODULE: ./src/components/content/BrowseLinks.tsx

/* eslint-disable camelcase */ 








/**
 * Convert a word to proper Case.
 */ const titleWordCase = (txt)=>`${txt.charAt(0).toUpperCase()}${txt.substr(1).toLowerCase()}`;
const regex = /([~!@#$%^&*\]){}_+\-(\s])/ig;
/**
 * Convert a sentence to proper Case.
 */ const titleCase = (txt)=>txt.split(regex).map(titleWordCase).join("");
/**
 * Generates a link to the browse state page for this job title.
 *
 * @returns {ReactElement}.
 */ const BrowseLinks = ()=>{
    const router = (0,next_router.useRouter)();
    const { asPath  } = router;
    const { publicRuntimeConfig: { museWebHost  }  } = (0,config["default"])();
    const { location: { userSelectedLocation  } , keyword: { userInputValue  }  } = useSearchState();
    const { 0: relatedCities , 1: setRelatedCities  } = (0,react.useState)([]);
    const keyword = (0,string/* slugify */.lV)(titleNormalization(userInputValue)) || "";
    const state = (0,string/* slugify */.lV)(userSelectedLocation.label || "").split("-").pop() ?? "";
    const titleCaseKeyWord = titleCase(keyword.split("-").join(" "));
    const stateName = constants/* states.find */.$q.find((x)=>x[1] === state.toUpperCase())?.slice(0, 1) ?? "";
    (0,react.useEffect)(()=>{
        (0,api/* fetchJobTitleCities */.yZ)(keyword, state.toUpperCase()).then((x)=>setRelatedCities(x?.cities ?? [])).catch(console.error);
    }, [
        keyword,
        state
    ]);
    const href = `${museWebHost}/browse/job-titles/${keyword}/${state.toUpperCase()}`;
    if (!asPath.includes("/hiring") || !relatedCities?.length) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (BrowseLinks_module_default()).browserLinks,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: href,
            children: `${titleCaseKeyWord} Jobs in ${stateName}`
        })
    });
};
BrowseLinks.displayName = "BrowseLinks";


// EXTERNAL MODULE: ./src/components/content/SideBySideJDP.module.scss
var SideBySideJDP_module = __webpack_require__(6392);
var SideBySideJDP_module_default = /*#__PURE__*/__webpack_require__.n(SideBySideJDP_module);
;// CONCATENATED MODULE: ./src/components/content/SideBySideJDP.tsx




/**
 * Generates a URL for a side-by-side job description Iframe.
 */ const generateSideBySideUrl = (job)=>{
    const { publicRuntimeConfig: { museWebHost  }  } = (0,config["default"])();
    // Add additional parameters to help the target site identify this as a legitimate iframe
    return job ? `${museWebHost}/jobs/${job}?framed` : "";
};
const Iframe = /*#__PURE__*/ (0,react.memo)(({ isOpen , iframeURL  })=>/*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
        className: (SideBySideJDP_module_default()).frame,
        title: "JDP",
        loading: "lazy",
        src: isOpen && iframeURL ? iframeURL : ""
    }));
Iframe.displayName = "Iframe";
const SideBySideJDP = ({ iframeRef , isOpen , setIsOpen , selectedJob , setSelectedJob  })=>{
    const iframeURL = selectedJob ? generateSideBySideUrl(selectedJob) : "";
    // Iframe close listener wipe selected job, iframe url and close the iframe.
    (0,react.useEffect)(()=>{
        const onReceivedCloseMessage = (event)=>{
            if (event.data === "closeSideBySide") {
                setSelectedJob(null);
                setIsOpen(false);
            }
        };
        window.addEventListener("message", onReceivedCloseMessage);
        return ()=>{
            window.removeEventListener("message", onReceivedCloseMessage);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: iframeRef,
        className: `${(SideBySideJDP_module_default()).frameWrapper} ${isOpen ? (SideBySideJDP_module_default()).frameWrapper_open : ""}`,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iframe, {
            isOpen,
            iframeURL
        })
    });
};
SideBySideJDP.displayName = "SideBySideJDP";

;// CONCATENATED MODULE: ./src/components/icons/IconClose.tsx

/* eslint-disable max-len */ 
/**
 * A functional React component that renders a Closing X SVG icon UI element.
 */ const IconClose = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M12.6667 4.27334L11.7267 3.33334L8 7.06001L4.27333 3.33334L3.33333 4.27334L7.06 8.00001L3.33333 11.7267L4.27333 12.6667L8 8.94001L11.7267 12.6667L12.6667 11.7267L8.94 8.00001L12.6667 4.27334Z",
            fill: "currentColor"
        })
    });

;// CONCATENATED MODULE: ./src/components/icons/IconCheckBox.tsx

/* eslint-disable max-len */ 
/**
 * A functional React component that renders a Checkbox SVG icon UI element.
 */ const IconCheckbox = ({ isSelected  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "17",
                height: "17",
                rx: "3.5",
                fill: isSelected ? "#1D2D5A" : "white",
                stroke: "#BEC2CA"
            }),
            isSelected && /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.33333 12.3333L3.5 8.49999L4.55833 7.44166L7.33333 10.2167L13.4417 4.10833L14.5 5.16666L7.33333 12.3333Z",
                fill: "white"
            })
        ]
    });

;// CONCATENATED MODULE: ./src/components/icons/IconRadio.tsx

/* eslint-disable max-len */ 
/**
 * A functional React component that renders a Radio SVG icon UI element.
 */ const IconRadio = ({ isSelected  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "9",
                cy: "9",
                r: "8.5",
                fill: "white",
                stroke: "#BEC2CA"
            }),
            isSelected && /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "9",
                cy: "9",
                r: "5",
                fill: "#1D2D5A"
            })
        ]
    });

// EXTERNAL MODULE: ./src/components/FilterNav/FilterOption.module.scss
var FilterOption_module = __webpack_require__(4605);
var FilterOption_module_default = /*#__PURE__*/__webpack_require__.n(FilterOption_module);
;// CONCATENATED MODULE: ./src/components/FilterNav/FilterOption.tsx

/* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/no-noninteractive-tabindex */ /* EsLint is unable to read a rule with a dynamic property like role={isRadioGroup ? "radio" : "checkbox"} */ 



/**
 * `FilterOption` is a functional component that renders a selectable option
 * within a filter navigation menu. It supports both radio and checkbox
 * selection types, determined by the `isRadioGroup` prop.
 */ const FilterOption = ({ label , value , isSelected , onSelect , isRadioGroup  })=>{
    const handleKeyPress = (e)=>{
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onSelect(value);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (FilterOption_module_default()).optionContainer,
        onClick: ()=>onSelect(value),
        onKeyDown: handleKeyPress,
        role: isRadioGroup ? "radio" : "checkbox",
        "aria-checked": isSelected,
        tabIndex: 0,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (FilterOption_module_default()).iconWrapper,
                children: isRadioGroup ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRadio, {
                    isSelected: isSelected
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCheckbox, {
                    isSelected: isSelected
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (FilterOption_module_default()).optionLabel,
                children: label
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/FilterNav/FilterPanel.module.scss
var FilterPanel_module = __webpack_require__(2884);
var FilterPanel_module_default = /*#__PURE__*/__webpack_require__.n(FilterPanel_module);
;// CONCATENATED MODULE: ./src/components/icons/IconLeftArrow.tsx

/* eslint-disable max-len */ 
/**
 * A functional React component that renders a Radio SVG icon UI element.
 */ const IconLeftArrow = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "13",
        height: "13",
        viewBox: "0 0 13 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.08951 2.38236L6.6753 0.968146L1.01845 6.625L6.6753 12.2819L8.08951 10.8676L3.84687 6.625L8.08951 2.38236Z",
            fill: "#666666"
        })
    });

;// CONCATENATED MODULE: ./src/components/FilterNav/FilterPanel.tsx








/**
 * `FilterPanel` component provides a UI for selecting individual filter options.
 */ const FilterPanel = ({ filterID , isOpen =false , label , options , onCancel , onApply , onBackBtn  })=>{
    const searchDispatch = useSearchDispatch();
    const { filters  } = useSearchState();
    // Radio groups take strings while all the others use string arrays.
    const isRadioGroup = [
        "postedDateRange",
        "radius",
        "allFiltersBtn"
    ].includes(filterID);
    const isAllFilters = filterID === "allFiltersBtn" ? (FilterPanel_module_default()).allFilters : "";
    // Check if this value is selected.
    const isChecked = (value)=>{
        try {
            return isRadioGroup ? filters[filterID] === value : filters[filterID].includes(value);
        } catch (error) {
            console.error(`Error checking isChecked Filter: ${filterID} : Item: ${value}`);
            return false;
        }
    };
    /**
     * Check if the currently selected items are different than the current search result filters.
     */ const hasSelections = isRadioGroup ? !!filters[filterID] : !!filters[filterID].length;
    const updateCheckState = (value)=>isChecked(value) ? filters[filterID].filter((item)=>item !== value) : [
            ...filters[filterID],
            value
        ];
    const updateRadioState = (value)=>isChecked(value) ? "" : value;
    /**
     * Handles the selection of an item by its value.
     * Toggles the item's presence in the selections list:
     * - If the item is already selected, it removes it.
     * - If the item is not selected, it adds it.
     */ const onSelect = (value)=>{
        searchDispatch({
            type: FiltersActionTypes.updateFilter,
            payload: {
                [filterID]: isRadioGroup ? updateRadioState(value) : updateCheckState(value)
            }
        });
    };
    const onReset = ()=>{
        searchDispatch({
            type: FiltersActionTypes.updateFilter,
            payload: {
                [filterID]: isRadioGroup ? "" : []
            }
        });
    };
    /**
     * Handles the cancellation of the current operation by invoking the onCancel callback
     * and resetting the selections to an empty array.
     */ const onCancelClose = ()=>{
        onCancel();
    };
    const onSubmit = ()=>{
        // currently this only closes the panel. this is because the checking of an item preforms a filter.
        // this button is only for show.
        onApply();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: `${(FilterPanel_module_default()).container} ${isOpen ? (FilterPanel_module_default()).open : ""} ${isAllFilters}`,
        role: "dialog",
        "aria-label": "Filter options",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (FilterPanel_module_default()).FilterPanelMenu,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    className: (FilterPanel_module_default()).closeButton,
                    onClick: onCancelClose,
                    "aria-label": "Close",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (FilterPanel_module_default()).menuHeader,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            type: "button",
                            onClick: onBackBtn,
                            "aria-label": "Back to all filters",
                            className: (FilterPanel_module_default()).backButton,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconLeftArrow, {}),
                                "All Filters"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (FilterPanel_module_default()).panelTitle,
                            children: label
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (FilterPanel_module_default()).filterContent,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (FilterPanel_module_default()).optionsContainer,
                        role: isRadioGroup ? "radiogroup" : "group",
                        children: options.map((option)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(FilterOption, {
                                value: option.value,
                                label: option.label,
                                isSelected: isChecked(option.value),
                                isRadioGroup: isRadioGroup,
                                onSelect: ()=>onSelect(option.value)
                            }, option.value))
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (FilterPanel_module_default()).actionButtons,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: (FilterPanel_module_default()).cancelButton,
                            onClick: hasSelections ? onReset : onCancelClose,
                            children: hasSelections ? "Reset" : "Cancel"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: (FilterPanel_module_default()).applyButton,
                            onClick: onSubmit,
                            children: "Apply"
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/icons/IconArrow.tsx

/* eslint-disable max-len */ 
/**
 * A functional React component that renders a Arrow/Carrot SVG icon UI element.
 */ const IconArrow = ({ className  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        className: className,
        width: "9",
        height: "9",
        viewBox: "0 0 9 9",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        "aria-labelledby": "icon-arrow",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#a)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#333",
                    stroke: "#303237",
                    strokeWidth: ".784",
                    d: "m4.762 5.991-.274.267-.273-.267-2.86-2.789-.312.312L4.488 6.96l3.446-3.446-.312-.312-2.86 2.789Z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M.488.93h8v8h-8z"
                    })
                })
            })
        ]
    });

// EXTERNAL MODULE: ./src/components/FilterNav/FilterTrigger.module.scss
var FilterTrigger_module = __webpack_require__(1642);
var FilterTrigger_module_default = /*#__PURE__*/__webpack_require__.n(FilterTrigger_module);
// EXTERNAL MODULE: ./src/components/icons/ToggleSwitch.module.scss
var ToggleSwitch_module = __webpack_require__(7796);
var ToggleSwitch_module_default = /*#__PURE__*/__webpack_require__.n(ToggleSwitch_module);
;// CONCATENATED MODULE: ./src/components/icons/ToggleSwitch.tsx



/**
 * A functional React component that renders a toggle switch UI element.
 */ const ToggleSwitch = ({ isOn , onToggle  })=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ToggleSwitch_module_default()).toggleContainer,
        onClick: onToggle,
        onKeyDown: (e)=>{
            if (e.key === "Enter" || e.key === " ") {
                onToggle();
            }
        },
        role: "switch",
        "aria-checked": isOn,
        tabIndex: 0,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            className: (ToggleSwitch_module_default()).toggleTrack,
            xmlns: "http://www.w3.org/2000/svg",
            width: "40",
            height: "24",
            viewBox: "0 0 40 24",
            fill: "none",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: isOn ? 0.644531 : 0.176758,
                    y: "0.715088",
                    width: "40",
                    height: "22.2222",
                    rx: "11.1111",
                    fill: isOn ? "#1D2D5A" : "#9EA1A8"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    cx: isOn ? 29.5336 : 11.2875,
                    cy: "11.8258",
                    r: "8.88906",
                    fill: "#D9D9D9"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    cx: isOn ? 6.6441 : 6.17632,
                    cy: "20.7151",
                    r: "0.222222",
                    fill: "#1D2D5A"
                })
            ]
        })
    });

;// CONCATENATED MODULE: ./src/components/FilterNav/FilterTrigger.tsx







/**
 * `FilterTrigger` is a functional component that renders a filter button with optional
 * sub-menu functionality. It displays the count of active filters and provides a toggle
 * for remote filter. The component can be customized with icons and
 * different styles based on its props.
 */ const FilterTrigger = ({ id , label , options , hasIcon =false , disabled =false , onClick =()=>{} , onCancel =()=>{} , onBackBtn =()=>{} , isOpen =false , isMegaMenu =false , wrapperClass =""  })=>{
    const { location: { userSelectedLocation  } , filters  } = useSearchState();
    // Determines the count of active filters for a specific filter type.
    const singleFilterCount = ()=>{
        if (id === "remote") {
            return userSelectedLocation?.remote_work_location_type ? 1 : 0;
        }
        if (id === "postedDateRange") {
            return filters.postedDateRange ? 1 : 0;
        }
        if (id === "radius") {
            return filters.radius ? 1 : 0;
        }
        return filters[id].filter(Boolean).length;
    };
    // Count to display on the button..
    const btnCounter = singleFilterCount();
    // Submit the items to the backend and fire the supplied onclick event.
    const onApply = ()=>{
        onClick();
    };
    const btnClass = `${(FilterTrigger_module_default()).FilterPanelBase} ${btnCounter ? (FilterTrigger_module_default()).active : ""}`;
    const hasSubMenu = !(isMegaMenu || id === "remote" || disabled);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: `${(FilterTrigger_module_default()).filterBarDropdowns} ${wrapperClass}`,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: btnClass,
                type: "button",
                tabIndex: 0,
                "aria-label": `Filter by ${label}`,
                onClick: onClick,
                disabled: disabled,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (FilterTrigger_module_default()).inputWrapper,
                        children: label
                    }),
                    id !== "remote" && btnCounter ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (FilterTrigger_module_default()).filter,
                        "aria-label": `${btnCounter} selected`,
                        children: btnCounter
                    }) : null,
                    id === "remote" && isMegaMenu ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleSwitch, {
                        isOn: !!btnCounter,
                        onToggle: onClick
                    }) : null,
                    hasIcon ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (FilterTrigger_module_default()).icons,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconArrow, {
                            className: `${(FilterTrigger_module_default()).img} ${isOpen ? (FilterTrigger_module_default()).open : ""}`
                        })
                    }) : null
                ]
            }),
            hasSubMenu ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterPanel, {
                filterID: id,
                label,
                isOpen,
                options,
                onCancel,
                onApply,
                onBackBtn
            }) : null
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/icons/IconFilter.tsx

/* eslint-disable max-len */ 
/**
 * A functional React component that renders a Filter SVG icon UI element.
 */ const IconFilter = ({ className  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: "16px",
        height: "16px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "4",
                rx: "2",
                ry: "2",
                cy: "3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "12",
                rx: "2",
                ry: "2",
                cy: "8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "4",
                rx: "2",
                ry: "2",
                cy: "13"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M 0 3 L 16 3",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M 0 13 L 16 13",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M 0 8 L 16 8",
                strokeLinecap: "round"
            })
        ]
    });

// EXTERNAL MODULE: ./src/components/FilterNav/FilterPanelCollection.module.scss
var FilterPanelCollection_module = __webpack_require__(1028);
var FilterPanelCollection_module_default = /*#__PURE__*/__webpack_require__.n(FilterPanelCollection_module);
;// CONCATENATED MODULE: ./src/components/FilterNav/FilterPanelCollection.tsx








const companyFilters = [
    "perks",
    "companySize",
    "industry",
    "companyLeadership",
    "diversityInclusionItems"
];
const jobFilters = [
    "postedDateRange",
    "category",
    "experienceLevel",
    "remote",
    "radius"
];
// Some buttons should be disabled if you have selected a company or have not selected a physical location yet.
const isDisabled = (id, userSelectedLocation, userSelectedCompany)=>{
    const hasLocation = !!userSelectedLocation.value;
    const isLocationProp = [
        "radius"
    ].includes(id);
    const hasCompany = !!userSelectedCompany?.value;
    const isCompanyProp = [
        "companySize",
        "industry",
        "perks",
        "companyLeadership"
    ].includes(id);
    return !!(isCompanyProp && hasCompany || isLocationProp && !hasLocation || isLocationProp && hasLocation && userSelectedLocation.remote_work_location_type === "virtual");
};
/**
 * `FilterPanelCollection` is a functional component that renders a collection of triggers
 * for job and company filters. Unlike FilterNav, these triggers do not have their own panels.
 * Instead, they toggle the Parent FilterNav trigger panels.
 */ const FilterPanelCollection = ({ isOpen =false , buttonOptions , onApply =()=>{} , onBackBtn , toggleSoloMenu , toggleMegaMenu , reset , openState  })=>{
    const { company: { userSelectedCompany  } , location: { userSelectedLocation  }  } = useSearchState();
    const companyButtons = buttonOptions.filter((item)=>companyFilters.includes(item.id));
    const jobButtons = buttonOptions.filter((item)=>jobFilters.includes(item.id));
    if ((0,browser/* isMobile */.tq)()) {
        (0,browser/* toggleWindowFreeze */.LF)();
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: `${(FilterPanelCollection_module_default()).container} ${isOpen ? "" : (FilterPanelCollection_module_default()).hidden}`,
        role: "dialog",
        "aria-label": "Filter options",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: (FilterPanelCollection_module_default()).closeButton,
                onClick: toggleMegaMenu,
                "aria-label": "Close filter menu",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (FilterPanelCollection_module_default()).expandable,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (FilterPanelCollection_module_default()).sectionHeader,
                        children: "Job Filters"
                    }),
                    jobButtons.map((filter)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(FilterTrigger, {
                            id: filter.id,
                            label: filter.label,
                            options: filter.options,
                            hasIcon: filter.hasIcon,
                            onClick: ()=>toggleSoloMenu(filter.id),
                            onBackBtn: ()=>onBackBtn(filter.id),
                            disabled: isDisabled(filter.id, userSelectedLocation, userSelectedCompany),
                            isOpen: openState[filter.id],
                            isMegaMenu: true,
                            wrapperClass: (FilterPanelCollection_module_default()).wrapperClass
                        }, filter.label)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (FilterPanelCollection_module_default()).sectionHeader,
                        children: "Company Filters"
                    }),
                    companyButtons.map((filter)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(FilterTrigger, {
                            id: filter.id,
                            label: filter.label,
                            options: filter.options,
                            hasIcon: filter.hasIcon,
                            onClick: ()=>toggleSoloMenu(filter.id),
                            onBackBtn: ()=>onBackBtn(filter.id),
                            disabled: isDisabled(filter.id, userSelectedLocation, userSelectedCompany),
                            isOpen: openState[filter.id],
                            isMegaMenu: true,
                            wrapperClass: (FilterPanelCollection_module_default()).wrapperClass
                        }, filter.label))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (FilterPanel_module_default()).actionButtons,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: (FilterPanel_module_default()).cancelButton,
                        onClick: reset,
                        children: "Reset All"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: (FilterPanel_module_default()).applyButton,
                        onClick: onApply,
                        children: "Apply"
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/FilterNav/FilterNav.module.scss
var FilterNav_module = __webpack_require__(4328);
var FilterNav_module_default = /*#__PURE__*/__webpack_require__.n(FilterNav_module);
;// CONCATENATED MODULE: ./src/components/FilterNav/FilterNav.tsx

/* eslint-disable camelcase */ 










const hasSelections = (filter)=>filter.count > 0 || filter.count === 0 && filter.active;
// all buttons should be closed by default
const defaultButtonsStates = {
    postedDateRange: false,
    experienceLevel: false,
    remote: false,
    radius: false,
    category: false,
    companySize: false,
    perks: false,
    industry: false,
    companyLeadership: false
};
// default location state
const nullLocation = {
    userInputValue: "",
    userSelectedLocation: {
        label: "",
        latitude: null,
        longitude: null,
        value: "",
        remote_work_location_type: null
    }
};
// the remote location state
const remoteLocation = {
    userInputValue: "Remote / Flexible",
    userSelectedLocation: {
        label: "Remote / Flexible",
        value: "Remote / Flexible",
        latitude: null,
        longitude: null,
        remote_work_location_type: "virtual",
        id: 0
    }
};
/**
 * `FilterNav` is a React functional component that renders a navigation bar
 * for filtering job search results. It manages the state of filter options
 * and handles user interactions such as opening and closing filter menus,
 * resetting filters, and updating search criteria based on user selections.
 */ const FilterNav = ({ onClear  })=>{
    const { company , location , keyword , filters  } = useSearchState();
    const { userSelectedCompany  } = company;
    const { userSelectedLocation  } = location;
    const { companyFacets: { perks_and_benefits  }  } = useSearchFacetsState();
    const searchDispatch = useSearchDispatch();
    const { 0: openState , 1: setOpenState  } = (0,react.useState)({
        ...defaultButtonsStates
    });
    const { 0: openMega , 1: setOpenMega  } = (0,react.useState)(false);
    /**
     * Handles click events outside of specified filter panel elements.
     */ const handleClickOutside = (event)=>{
        const target = event.target;
        let currentElement = target;
        const prefixes = [
            "FilterTrigger_FilterPanelBase",
            "FilterPanelCollection_container",
            "FilterPanel_container"
        ];
        const checkPrefix = (prefix)=>currentElement.className.toString().startsWith(prefix);
        // check this element and its parents
        while(currentElement){
            if (currentElement.className && prefixes.some(checkPrefix)) {
                return; // Stop execution if a matching element is found
            }
            currentElement = currentElement.parentElement;
        }
        // If no matching parent element is found, execute the closing logic
        setOpenMega(false);
        setOpenState({
            ...defaultButtonsStates
        });
    };
    // useEffect to add event listener for click outside of filter panels.
    (0,react.useEffect)(()=>{
        // Add event listener when component mounts
        document.addEventListener("click", handleClickOutside);
        // Remove event listener when component unmounts
        return ()=>{
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);
    // Determines if a filter option should be disabled based on the current user selections.
    const isDisabled = (id)=>{
        const hasLocation = !!userSelectedLocation.value;
        const isLocationProp = [
            "radius"
        ].includes(id);
        const hasCompany = !!userSelectedCompany?.value;
        const isCompanyProp = [
            "companySize",
            "industry",
            "perks",
            "companyLeadership"
        ].includes(id);
        return !!(isCompanyProp && hasCompany || isLocationProp && !hasLocation || isLocationProp && hasLocation && userSelectedLocation.remote_work_location_type === "virtual");
    };
    const perks = (0,searchFacetItems/* flattenPerksAndBenefits */.sg)(perks_and_benefits);
    // list of buttons
    // * hasIcon: show the open close arrow icon
    // * solo: should show in the top nav bar independently of the mega dropdown.
    const buttonOptions = [
        {
            id: "postedDateRange",
            label: "Date Posted",
            hasIcon: true,
            solo: true,
            options: searchFacetItems/* postedDateRangeItems */.dK
        },
        {
            id: "experienceLevel",
            label: "Experience Level",
            hasIcon: true,
            solo: true,
            options: searchFacetItems/* experienceLevelItems */.s
        },
        {
            id: "remote",
            label: "Remote/Flexible Only",
            hasIcon: false,
            solo: true,
            options: []
        },
        {
            id: "radius",
            label: "Search Radius",
            hasIcon: true,
            solo: true,
            options: searchFacetItems/* searchRadiusItems */.Z5
        },
        {
            id: "category",
            label: "Job Category",
            hasIcon: true,
            solo: true,
            options: searchFacetItems/* jobCategoryItems */.Y0
        },
        {
            id: "perks",
            label: "Perks and Benefits",
            hasIcon: true,
            solo: true,
            options: perks
        },
        {
            id: "companySize",
            label: "Company Size",
            hasIcon: true,
            solo: true,
            options: searchFacetItems/* companySizeItems */.NB
        },
        {
            id: "industry",
            label: "Company Industry",
            hasIcon: true,
            solo: false,
            options: searchFacetItems/* companyIndustryItems */.fA
        },
        {
            id: "companyLeadership",
            label: "Diversity & Inclusion",
            hasIcon: true,
            solo: false,
            options: searchFacetItems/* diversityInclusionItems */.uq
        }
    ];
    // Enabled with selections come first
    const selectedFilters = buttonOptions.filter((btn)=>hasSelections(btn) && !!btn.solo && !isDisabled(btn.id));
    // Enabled without selections come after
    const unSelectedFilters = buttonOptions.filter((x)=>!hasSelections(x) && !!x.solo && !isDisabled(x.id));
    // Disabled always come last
    const disabledFilters = buttonOptions.filter((x)=>!!x.solo && isDisabled(x.id));
    // Everything else.
    const extraFilters = buttonOptions.filter((x)=>!x.solo);
    // Total count of all filters and their options currently active
    const filterCount = getSelectedFiltersCount({
        filters,
        location,
        company,
        keyword
    });
    const remoteSubmit = (id)=>{
        if (id === "remote" && !userSelectedLocation.remote_work_location_type) {
            searchDispatch({
                type: LocationActionTypes.updateLocation,
                payload: remoteLocation
            });
            if (filters?.radius) {
                searchDispatch({
                    type: FiltersActionTypes.updateFilter,
                    payload: {
                        radius: ""
                    }
                });
            }
        }
        if (id === "remote" && userSelectedLocation.remote_work_location_type) {
            searchDispatch({
                type: LocationActionTypes.updateLocation,
                payload: nullLocation
            });
        }
    };
    /**
     * Toggles the open state of a specific filter panel identified by the given key.
     */ const toggleMenu = (key)=>{
        setOpenState((prev)=>({
                ...defaultButtonsStates,
                [key]: !prev[key]
            }));
    };
    /**
     * Toggles the state of the mega menu.
     *
     * This function resets the open state of buttons to their default
     * and toggles the open state of the mega menu.
     */ const toggleMegaMenu = ()=>{
        setOpenState(()=>({
                ...defaultButtonsStates
            }));
        setOpenMega((prev)=>!prev);
    };
    /**
     * Toggles the visibility of a specific menu panel based on the provided key.
     *
     * If the key is "remote", it triggers a remote submission instead of toggling.
     * Updates the state of the panel and button visibility.
     */ const toggleSoloMenu = (key, closeMegaMenu)=>{
        // the remote button does not have a menu so we instead submit here
        if (key === "remote") {
            remoteSubmit(key);
        }
        // update the panel and button states
        toggleMenu(key);
        if (closeMegaMenu) {
            setOpenMega(false);
        }
    };
    /**
     * Toggles the open state of a specific filter button and closes the mega menu.
     */ const onCancel = (key)=>{
        toggleMenu(key);
        setOpenMega(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
        className: (FilterNav_module_default()).allFilters,
        "aria-label": "Job filters",
        "data-mega-open": openMega,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (FilterNav_module_default()).buttonWrapper,
                children: [
                    selectedFilters.map((filter)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(FilterTrigger, {
                            options: filter.options,
                            id: filter.id,
                            disabled: isDisabled(filter.id),
                            onClick: ()=>toggleSoloMenu(filter.id, true),
                            onCancel: ()=>onCancel(filter.id),
                            onBackBtn: ()=>toggleMenu(filter.id),
                            label: filter.label,
                            hasIcon: filter.hasIcon,
                            isOpen: openState[filter.id],
                            isMegaMenu: false
                        }, filter.label)),
                    unSelectedFilters.map((filter)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(FilterTrigger, {
                            options: filter.options,
                            id: filter.id,
                            disabled: isDisabled(filter.id),
                            onClick: ()=>toggleSoloMenu(filter.id, true),
                            onCancel: ()=>onCancel(filter.id),
                            onBackBtn: ()=>toggleMenu(filter.id),
                            label: filter.label,
                            hasIcon: filter.hasIcon,
                            isOpen: openState[filter.id],
                            isMegaMenu: false
                        }, filter.label)),
                    disabledFilters.map((filter)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(FilterTrigger, {
                            options: filter.options,
                            id: filter.id,
                            disabled: isDisabled(filter.id),
                            onClick: ()=>toggleSoloMenu(filter.id, true),
                            onCancel: ()=>onCancel(filter.id),
                            onBackBtn: ()=>toggleMenu(filter.id),
                            label: filter.label,
                            hasIcon: filter.hasIcon,
                            isOpen: openState[filter.id],
                            isMegaMenu: false
                        }, filter.label)),
                    extraFilters.map((filter)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(FilterTrigger, {
                            options: filter.options,
                            id: filter.id,
                            disabled: isDisabled(filter.id),
                            onClick: ()=>toggleSoloMenu(filter.id, true),
                            onCancel: ()=>onCancel(filter.id),
                            onBackBtn: ()=>toggleMenu(filter.id),
                            label: filter.label,
                            hasIcon: filter.hasIcon,
                            isOpen: openState[filter.id],
                            isMegaMenu: false
                        }, filter.label))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (FilterNav_module_default()).resetWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: (FilterNav_module_default()).reset,
                        onClick: onClear,
                        "aria-label": "Reset all filters",
                        children: "Reset All"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: `${(FilterTrigger_module_default()).FilterPanelBase} ${filterCount ? (FilterTrigger_module_default()).active : ""}`,
                        type: "button",
                        tabIndex: 0,
                        "aria-label": "All Filters",
                        onClick: toggleMegaMenu,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: `${(FilterNav_module_default()).icons} ${(FilterNav_module_default()).filterIcon}`,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconFilter, {
                                    className: `${(FilterNav_module_default()).filterIcon} ${openMega ? (FilterNav_module_default()).open : ""}`
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (FilterNav_module_default()).inputWrapper,
                                children: "All Filters"
                            }),
                            filterCount ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (FilterNav_module_default()).counter,
                                "aria-label": `${filterCount} selected`,
                                children: filterCount
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: " "
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterPanelCollection, {
                        isOpen: openMega,
                        buttonOptions,
                        onCancel: ()=>setOpenMega(false),
                        onApply: ()=>setOpenMega(false),
                        onBackBtn: toggleMenu,
                        openState,
                        toggleSoloMenu,
                        toggleMegaMenu,
                        reset: onClear
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/content/SearchPageLayout.module.scss
var SearchPageLayout_module = __webpack_require__(8391);
var SearchPageLayout_module_default = /*#__PURE__*/__webpack_require__.n(SearchPageLayout_module);
;// CONCATENATED MODULE: ./src/components/content/SearchPageLayout.tsx

/* eslint-disable camelcase */ 












/**
 * Renders the SearchPageLayout component, which provides the layout for the search page.
 * It includes a search input, filter navigation, and search results display.
 *
 * The component manages the state for clearing inputs, opening job details, and selecting jobs.
 * It automatically opens the first job if available and the screen width is larger than 992px.
 *
 * Utilizes feature flags to conditionally render a side-by-side job details pane.
 */ const SearchPageLayout = ({ job ="" , page =1  })=>{
    const user = (0,UserContext/* useUserState */.e)();
    const { results  } = useSearchResultsState();
    const { 0: clearInputs , 1: setClearInputs  } = (0,react.useState)(false);
    // Side by Side JDP State
    const { 0: isOpen , 1: setIsOpen  } = (0,react.useState)(false);
    // Direct Apply Modal State
    const { 0: isDirectApplyOpen , 1: setIsDirectApplyOpen  } = (0,react.useState)(false);
    const { 0: selectedJob , 1: setSelectedJob  } = (0,react.useState)(job);
    const isMobile = ()=>(0,browser/* isBrowser */.jU)() && window.innerWidth <= 992;
    const contentRef = (0,react.useRef)(null);
    const iframeRef = (0,react.useRef)(null);
    // Populated from the JDP iframe via the 'message" api.
    const { 0: directApplyProps , 1: setDirectApplyProps  } = (0,react.useState)(null);
    const [activePage, setActivePage] = react.useState(page);
    /**
     * Reset clearInputs back to false after it's been set to true
     */ (0,react.useEffect)(()=>{
        if (clearInputs) {
            // Allow time for the clear action to be processed
            const timer = setTimeout(()=>{
                setClearInputs(false);
                setActivePage(1);
            }, 100);
            return ()=>clearTimeout(timer);
        }
        return undefined;
    }, [
        clearInputs
    ]);
    /**
     * update the direct apply modal's data this happens when the iframe page loads.
     * example: window.top.postMessage({ name: "updateDirectApply", job }, "*");
     */ (0,react.useEffect)(()=>{
        const onUpdateDirectApplyMessage = (event)=>{
            if (event.data?.name === "updateDirectApply" && event.data?.job) {
                setDirectApplyProps((prev)=>({
                        ...prev,
                        ...event.data.job
                    }));
            }
        };
        window.addEventListener("message", onUpdateDirectApplyMessage);
        return ()=>{
            window.removeEventListener("message", onUpdateDirectApplyMessage);
        };
    }, []);
    /**
     * Update the open state of the direct apply modal
     * example: `window.top.postMessage("openDirectApply", "*");`
     */ (0,react.useEffect)(()=>{
        const onApplyButtonMessage = (event)=>{
            if (event.data === "openDirectApply") {
                setIsDirectApplyOpen(true);
            }
        };
        window.addEventListener("message", onApplyButtonMessage);
        return ()=>{
            window.removeEventListener("message", onApplyButtonMessage);
        };
    }, []);
    /**
     * Auto open sidebar
     */ (0,react.useEffect)(()=>{
        // no auto open on mobile
        if (isMobile()) return;
        // auto open preselected job
        if (selectedJob) {
            setIsOpen(true);
        }
        // auto open calculated job
        if (!selectedJob) {
            const jobToUse = results[0]?.hit ?? null;
            const jobPath = jobToUse ? `${jobToUse.company.short_name}/${jobToUse.short_title}` : null;
            setSelectedJob(jobPath);
            setIsOpen(!!jobPath);
        }
    }, [
        results,
        job
    ]);
    const pageLayoutProps = {
        activePath: "/search",
        headerClassName: (SearchPageLayout_module_default()).pageHeader,
        footerClassName: (SearchPageLayout_module_default()).pageFooter,
        pageName: (SearchPageLayout_module_default()).pageWrapper,
        mainClassName: (SearchPageLayout_module_default()).main,
        showSubMenus: true,
        user,
        handleModalFormSubmit: api/* newsletterSubscribeRequest */.Pl
    };
    const onClear = ()=>{
        setClearInputs(true);
        setActivePage(1);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        ...pageLayoutProps,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: (SearchPageLayout_module_default()).header,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(header_SearchInput, {
                    clearInputs: clearInputs,
                    onClear: onClear
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterNav, {
                onClear: onClear
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                ref: contentRef,
                className: `${(SearchPageLayout_module_default()).content} ${!selectedJob || !isOpen ? (SearchPageLayout_module_default()).closed : ""}`,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResults, {
                        onClear: onClear,
                        setIsOpen,
                        setSelectedJob,
                        selectedJob,
                        activePage,
                        setActivePage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BrowseLinks, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SideBySideJDP, {
                iframeRef,
                isOpen,
                setIsOpen,
                selectedJob,
                setSelectedJob
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DirectApplyModal, {
                ...directApplyProps,
                isDirectApplyOpen,
                setIsDirectApplyOpen
            }, directApplyProps?.atsJobId ?? "none")
        ]
    });
};
SearchPageLayout.displayName = "SearchPageLayout";

;// CONCATENATED MODULE: ./src/pages/index.tsx
















/**
 * Convert the job level into an array of strings that the API can understand.
 */ const convertExperienceLevel = (level)=>{
    const result = level.split(",").map((levelValue)=>{
        if ([
            "senior",
            "management"
        ].includes(levelValue)) {
            return "senior,management";
        }
        return levelValue;
    });
    return [
        ...new Set(result)
    ];
};
/**
 * Convert the selected location into an array of strings that the API can understand.
 */ const convertSelectedLocation = (location)=>({
        label: location.label === "Flexible / Remote" ? "Remote / Flexible" : location.label,
        latitude: parseFloat(location.latitude),
        longitude: parseFloat(location.longitude),
        remote_work_location_type: location.label === "Remote / Flexible" || location.label === "Flexible / Remote" ? "virtual" : "",
        value: location.value === "Flexible / Remote" ? "Remote / Flexible" : location.value
    });
var __N_SSP = true;
const getInitialFilterParams = (params)=>Object.keys(params).reduce((values, currentValue)=>{
        const localValues = values;
        if (![
            "location",
            "company"
        ].includes(currentValue)) {
            const decodedParamValue = decodeURIComponent(params[currentValue]);
            // Format keyword
            let value = decodedParamValue;
            if (currentValue === "keyword") {
                value = (0,strings/* titleCase */.Qs)(value.replace(/\+/g, " "));
            }
            localValues[currentValue] = value;
        }
        return localValues;
    }, {});
const getInitialSearchId = (reqUrl, reqHost)=>{
    const parsedUrl = new URL(reqUrl || "", `http://${reqHost || "www.example.com"}`);
    const searchIdValue = parsedUrl.searchParams.get("_search_id");
    return searchIdValue || (0,v4/* default */.Z)();
};
/**
 * Transforms initial search parameters into an object for use in search functionality.
 * `__NEXT_DATA__.props.pageProps.initialSearchState`
 */ const setInitialSearchState = (initialSearchParams, companyAttributes, initialDropDownCompanies, ctsEnabled)=>{
    const { location =null , company =null , keyword ="" , category ="" , industry ="" , level ="" , perks ="" , size ="" , radius ="" , "date-posted": postedDateRange = "" , "company-leadership": companyLeadership = "" , preference ="" , searchId =""  } = initialSearchParams;
    const { perks_and_benefits  } = companyAttributes;
    const experienceLevel = convertExperienceLevel(level);
    const radiusValues = getFacetValuesFromFacetItems(radius, searchFacetItems/* searchRadiusItems */.Z5);
    const initialRadius = location ? radiusValues[0] ?? "" : "";
    const postedDateRangeValues = getFacetValuesFromFacetItems(postedDateRange, searchFacetItems/* postedDateRangeItems */.dK);
    const initialPostedDateRange = postedDateRangeValues[0] ?? "";
    const pagination = ctsEnabled ? {} : {
        from_param: 1,
        size: 20
    };
    return {
        location: location ? {
            userInputValue: location.label,
            userSelectedLocation: convertSelectedLocation(location)
        } : {
            userInputValue: "",
            // we are not using the users location on the server.
            userSelectedLocation: {
                label: "",
                latitude: null,
                longitude: null,
                value: ""
            }
        },
        company: company ? {
            userSelectedCompany: {
                label: company.name,
                value: company.shortname
            },
            companySuggestions: initialDropDownCompanies
        } : {},
        keyword: {
            userInputValue: keyword || "",
            userSelectedKeyword: {
                label: keyword || "",
                value: keyword || ""
            }
        },
        filters: {
            experienceLevel,
            category: getFacetValuesFromFacetItems(category, searchFacetItems/* jobCategoryItems */.Y0),
            industry: getFacetValuesFromFacetItems(industry, searchFacetItems/* companyIndustryItems */.fA),
            perks: getFacetValuesFromFacetItems(perks, (0,searchFacetItems/* flattenPerksAndBenefits */.sg)(perks_and_benefits)),
            companyLeadership: getFacetValuesFromFacetItems(companyLeadership, searchFacetItems/* diversityInclusionItems */.uq),
            companySize: size?.length ? decodeURIComponent(size).split(",") : [],
            radius: initialRadius,
            postedDateRange: initialPostedDateRange
        },
        preference,
        searchId,
        ctsEnabled,
        ...pagination
    };
};
const snowplowPageData = {
    sp_page_is_external: false,
    sp_page_section: "search",
    sp_page_sponsor_id: null,
    sp_page_tab: null,
    sp_page_type: "collection",
    sp_experiment_experiment_id: "",
    sp_experiment_variant_id: ""
};
/**
 * Initializes the Snowplow tracker and triggers page view events based on user actions and experiment data.
 */ const SnowplowInit = ()=>{
    const user = (0,UserContext/* useUserState */.e)();
    const { publicRuntimeConfig  } = (0,config["default"])();
    const { 0: pageViewTriggered , 1: setPageViewTriggered  } = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        const enabledVariant = (0,build.getActiveVariant)("RECENT_SEARCHES", // eslint-disable-next-line no-underscore-dangle
        window?.__NEXT_DATA__?.props?.pageProps?.experiments ?? []);
        const experimentData = enabledVariant ? {
            sp_experiment_experiment_id: "RECENT_SEARCHES",
            sp_experiment_variant_id: enabledVariant
        } : {};
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            ...snowplowPageData,
            ...experimentData
        });
        if (publicRuntimeConfig?.snowplowCollector) {
            (0,snowplow_js_client_build.initSnowplowTracker)(publicRuntimeConfig.snowplowCollector);
        }
    }, []);
    (0,react.useEffect)(()=>{
        window.sp_user_logged_in = user.logged_in ?? false;
        window.sp_user_id = user.id ?? null;
    }, [
        user
    ]);
    // Note: Add snowplow pageview in a useEffect??
    // After a user api request attempt has been made??
    (0,react.useEffect)(()=>{
        if (user.isInitialized && !pageViewTriggered) {
            (0,snowplow_js_client_build.triggerSnowplowPageViewEvent)();
            setPageViewTriggered(true);
        }
    }, [
        user
    ]);
    return null;
};
const Home = (props)=>{
    const { resolvedUrl , carmenLocation , companyAttributes , featureFlags , initialSearchResultsState , initialSearchState ,  } = props;
    const search = new URLSearchParams(resolvedUrl.split("?")?.[1] ?? "");
    const job = search.get("job");
    const page = search.get("page");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserContext/* UserProvider */.d, {
        userLocation: carmenLocation,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureFlagsProvider, {
            featureFlags: featureFlags,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFacetsProvider, {
                companyFacets: companyAttributes,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchProvider, {
                    ...initialSearchState,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchResultsProvider, {
                        ...initialSearchResultsState,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SnowplowInit, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Seo, {
                                resolvedUrl
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchPageLayout, {
                                page: parseInt(page || "1", 10),
                                job: job
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var pages = (Home);


/***/ }),

/***/ 4328:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"allFilters":"FilterNav_allFilters__Cvxox","icons":"FilterNav_icons__MfWji","filterIcon":"FilterNav_filterIcon__h_anj","open":"FilterNav_open__ru_vY","counter":"FilterNav_counter__nXIDZ","reset":"FilterNav_reset__fYlgP","resetWrapper":"FilterNav_resetWrapper__P3kHD","img":"FilterNav_img__VpJUj","buttonWrapper":"FilterNav_buttonWrapper__LNh81"};

/***/ }),

/***/ 4605:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"FilterOption_container__DQesM","content":"FilterOption_content__39LoV","closeButton":"FilterOption_closeButton__X0BkW","optionsWrapper":"FilterOption_optionsWrapper__1uXta","optionContainer":"FilterOption_optionContainer__UhVFo","iconWrapper":"FilterOption_iconWrapper__85R_C","optionIcon":"FilterOption_optionIcon__OE5aj","optionLabel":"FilterOption_optionLabel__uE_n4","actions":"FilterOption_actions__5OHq_","cancelButton":"FilterOption_cancelButton__6j1Kp","applyButton":"FilterOption_applyButton__t1TD5"};

/***/ }),

/***/ 2884:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"FilterPanel_container__1qT3P","fadeIn":"FilterPanel_fadeIn__ItMKP","open":"FilterPanel_open__BmN_y","FilterPanelMenu":"FilterPanel_FilterPanelMenu__N79zN","closeButton":"FilterPanel_closeButton__ZO4Ds","menuHeader":"FilterPanel_menuHeader__H3H24","backButton":"FilterPanel_backButton__ntNZ8","panelTitle":"FilterPanel_panelTitle__8LioT","filterContent":"FilterPanel_filterContent__xlOsa","optionsContainer":"FilterPanel_optionsContainer__0ETYM","actionButtons":"FilterPanel_actionButtons__H967a","cancelButton":"FilterPanel_cancelButton__ZHfgU","applyButton":"FilterPanel_applyButton__FE0gr","fadeOut":"FilterPanel_fadeOut__g3c9V"};

/***/ }),

/***/ 1028:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"FilterPanelCollection_container__n2q0z","fadeIn":"FilterPanelCollection_fadeIn__nOeOp","hidden":"FilterPanelCollection_hidden__lagnN","fadeOut":"FilterPanelCollection_fadeOut__3zfjC","expandable":"FilterPanelCollection_expandable__T2s4j","wrapperClass":"FilterPanelCollection_wrapperClass__7EkJ_","sectionHeader":"FilterPanelCollection_sectionHeader__uFIUX","returnHeader":"FilterPanelCollection_returnHeader__X1hyo","closeButton":"FilterPanelCollection_closeButton__NW1m9"};

/***/ }),

/***/ 1642:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"filterBarDropdowns":"FilterTrigger_filterBarDropdowns__4IcTO","FilterPanelBase":"FilterTrigger_FilterPanelBase__Qrxol","hidden":"FilterTrigger_hidden__3Es6W","active":"FilterTrigger_active__eLaQ1","inputWrapper":"FilterTrigger_inputWrapper__B3TEC","filter":"FilterTrigger_filter__JZDuk","img":"FilterTrigger_img__CBD3t","filterDark":"FilterTrigger_filterDark__Lt0ZA","icons":"FilterTrigger_icons__aAUCC","allFilter":"FilterTrigger_allFilter__SLP8S","open":"FilterTrigger_open__HMMaZ"};

/***/ }),

/***/ 148:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"browserLinks":"BrowseLinks_browserLinks__Ax_xl"};

/***/ }),

/***/ 752:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"empty":"Empty_empty__FTeFV"};

/***/ }),

/***/ 9617:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"jobTile":"JobTileMinimal_jobTile__LbTdd","cta":"JobTileMinimal_cta__A9Su2","selected":"JobTileMinimal_selected__2ZVfv","title":"JobTileMinimal_title__1XdKb","logo":"JobTileMinimal_logo___wnxX","nullLogo":"JobTileMinimal_nullLogo__eAq4m","body":"JobTileMinimal_body__sGgvl","details":"JobTileMinimal_details__vd4sc"};

/***/ }),

/***/ 7686:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loadMore":"LoadMore_loadMore__Gi4JP"};

/***/ }),

/***/ 9661:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"jobApplyModalContainer":"DirectApplyModal_jobApplyModalContainer__PShdq","jobApplyModalContent":"DirectApplyModal_jobApplyModalContent__lBF3V","jobApplyModalCloseButton":"DirectApplyModal_jobApplyModalCloseButton__XwpuS"};

/***/ }),

/***/ 9413:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"JobAlertsModal_container__o8oog","content":"JobAlertsModal_content__79ml_"};

/***/ }),

/***/ 6822:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"paginationContainer":"Pagination_paginationContainer__wu0w7","paginationControls":"Pagination_paginationControls__GMHq3","pageNumbersContainer":"Pagination_pageNumbersContainer__lXZPw","pageButton":"Pagination_pageButton__P7lU9","disabled":"Pagination_disabled__F_ZSj","arrowButton":"Pagination_arrowButton__DAEIX"};

/***/ }),

/***/ 7614:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"alertCTA":"AlertCTA_alertCTA__z_Q9u","alertCTAHidden":"AlertCTA_alertCTAHidden__V59jS"};

/***/ }),

/***/ 8635:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"total":"Heading_total__11Z0e"};

/***/ }),

/***/ 3172:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchHeader_wrapper__sd2ab"};

/***/ }),

/***/ 8391:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"SearchPageLayout_content__ZfjE7","closed":"SearchPageLayout_closed__LzYFp","header":"SearchPageLayout_header__p_CzB"};

/***/ }),

/***/ 235:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"resultsGrid":"SearchResults_resultsGrid__pHY29","hasFade":"SearchResults_hasFade__KcoTL","frameWrapper":"SearchResults_frameWrapper__FB_ZV"};

/***/ }),

/***/ 6392:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"frameWrapper":"SideBySideJDP_frameWrapper__Tmsdh","frameWrapper_open":"SideBySideJDP_frameWrapper_open__fNKS9","frame":"SideBySideJDP_frame__r08kN"};

/***/ }),

/***/ 8619:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"SearchInput_form__SSK4O","inputSubmit":"SearchInput_inputSubmit__iTw2G","inputIcon":"SearchInput_inputIcon__NNp1D","searchInputContainer":"SearchInput_searchInputContainer__iYKqt","noResultsButton":"SearchInput_noResultsButton__CNbU_","noResultsButtonKeyword":"SearchInput_noResultsButtonKeyword__J6EXM"};

/***/ }),

/***/ 1601:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"nullLogo":"NullLogo_nullLogo__O38F1"};

/***/ }),

/***/ 7796:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"toggleTrack":"ToggleSwitch_toggleTrack___SnId"};

/***/ }),

/***/ 4865:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"Home_main__zgAJj","inputMenuOpen":"Home_inputMenuOpen__jnEXa","sidebar":"Home_sidebar__moo8u","showSidebar":"Home_showSidebar__I0bGu Home_sidebar__moo8u","filterToggle":"Home_filterToggle__N96mk"};

/***/ }),

/***/ 4654:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [990,564,652,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);